"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
define('app/templates',['handlebars'], function (Handlebars) {
  this["RSTemplates"] = this["RSTemplates"] || {};
  this["RSTemplates"]["cell.evigrid"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "	    <input type=\"checkbox\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.Checked : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " />\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "checked";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "	    " + escapeExpression((helper = (helper = helpers.Text || (depth0 != null ? depth0.Text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "Text",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"grid-col\" style=\"width: " + escapeExpression((helper = (helper = helpers.Width || (depth0 != null ? depth0.Width : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "Width",
          "hash": {},
          "data": data
        }) : helper)) + "px;\">\n	<span>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.Checkbox : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "	</span>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["init.evigrid"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "				<div class=\"column ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.noSort : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.Visible : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" colIndex=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" title=\"" + escapeExpression((helper = (helper = helpers.Description || (depth0 != null ? depth0.Description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "Description",
        "hash": {},
        "data": data
      }) : helper)) + "\" style=\"width:" + escapeExpression((helper = (helper = helpers.Width || (depth0 != null ? depth0.Width : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "Width",
        "hash": {},
        "data": data
      }) : helper)) + "px\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.CheckBox : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.program(10, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "				</div>\n				<div colIndex=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" class=\"grabber ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.Visible : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\">\n					<div></div>\n				</div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "no-sort";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "hidden";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "last";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "            <span>\n              <input type=\"checkbox\" />\n            </span>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "  					<div class=\"icon-sorting-icon\"></div>\n  					<span>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.DisplayName : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.program(13, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  					</span>\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  							" + escapeExpression((helper = (helper = helpers.DisplayName || (depth0 != null ? depth0.DisplayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "DisplayName",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "13": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  							" + escapeExpression((helper = (helper = helpers.Name || (depth0 != null ? depth0.Name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "Name",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"control-container\">\n	<div class=\"multicolumn-control\">\n		<div class=\"header-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.Headers : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "			<div class=\"clear\"></div>\n		</div>\n		<div class=\"row-container\">\n			<div class=\"height-element\">\n\n			</div>\n		</div>\n	</div>\n	<div class=\"footer-container\">\n		<div class=\"text\">0 items</div>\n	</div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["evimenu.default.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "	<li class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.disabled : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-index=\"" + escapeExpression((helper = (helper = helpers.i || (depth0 != null ? depth0.i : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "i",
        "hash": {},
        "data": data
      }) : helper)) + "\"><span>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0['fa-icon'] : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "		" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n	</span></li>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "			<i class=\"fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + "\"></i>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "			<i class=\"fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers['fa-icon'] || (depth0 != null ? depth0['fa-icon'] : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "fa-icon",
        "hash": {},
        "data": data
      }) : helper)) + "\"></i>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "		<li class=\"divider\"></li>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(8, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["RSTemplates"]["evimenu.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        buffer = "      ";
      stack1 = lambda(depth0, depth0);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"evi-dropdown " + escapeExpression((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "class",
          "hash": {},
          "data": data
        }) : helper)) + "\">\n  <ul>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.items : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </ul>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["insert.macro.modal.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"macro-modal-container\">\n	<div class=\"message\">Click the variable you want to insert</div>\n	<ul class=\"macro-list\">\n	</ul>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["macro.item.row"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<li>" + escapeExpression((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "display",
        "hash": {},
        "data": data
      }) : helper)) + "</li>";
    },
    "useData": true
  });
  this["RSTemplates"]["tree.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"argosWebTreeView\"></div>";
    },
    "useData": true
  });
  this["RSTemplates"]["tree.node.contents"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<span class=\"highlight padding rounded\">" + escapeExpression((helper = (helper = helpers.Name || (depth0 != null ? depth0.Name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "Name",
        "hash": {},
        "data": data
      }) : helper)) + "</span>";
    },
    "useData": true
  });
  this["RSTemplates"]["tree.node"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "      <div class=\"gridLine ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dotted : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\"></div>\n      <div class=\"gridLineHorizontal ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dotted : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return " dotted ";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"node\">\n  <div class=\"nodeData\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.gridLines : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    <div class=\"nodeExpand\"><i class=\"icon-chevron-right\"></i></div>\n    <div class=\"nodeContainer\"></div>\n  </div>\n  <div class=\"nodeChildren\"></div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["department.approvers"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"department-approver-list\">\n  <div class=\"department-approvers-container\"></div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["department.list"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "        <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary wide-view add-approver-btn\"><i class=\"fa-icon fa-icon-plus\"></i> ADD AN APPROVER</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"content-page-width full-height main-page-width\">\n  <div class=\"clearfix content-padding content-underline padding content-header content-page-width\">\n    <div class=\"clearfix pull-left\">\n      <div class=\"\">\n        <div class=\"large-title-text\">Manage Organizational Approvers</div>\n      </div>\n    </div>\n    <div class=\"edit-content-header pull-right clearfix\">\n      <div class=\"top-buttons\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.setOrgApproverPerm : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "      </div>\n    </div>\n  </div>\n  <div class=\"content-body\">\n    <div class=\"main-wrapper clearfix\">\n      <div class=\"left-wrapper\">\n        <div class=\"main-sidebar\">\n          <div class=\"sidebar-content-container\"></div>\n        </div>\n      </div>\n      <div class=\"right-wrapper\">\n        <div class=\"right-wrapper-wrapper\">\n          <div class=\"main-content\"></div>\n          <div class=\"choose-department empty-table-content\">\n            <br><br><br><i>Choose an organization on the left.</i><br><br>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["document.decision.categories"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "required-text";
    },
    "3": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <li class=\"category-list-item\">\n    <label>\n      <input ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0._selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers.unless.call(depth0, depths[1] != null ? depths[1].edit : depths[1], {
        "name": "unless",
        "hash": {},
        "fn": this.program(6, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " class=\"pull-left decision-category-checkbox\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\" data-property=\"category\" type=\"checkbox\" />\n      <div class=\"category-list-item-content\">\n        <div>\n          <div class=\"pull-left\">";
      stack1 = (helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ".&nbsp;&nbsp;</div> \n          ";
      stack1 = (helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n        </div>\n      </div>  \n    </label>\n  </li>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "checked=\"checked\"";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "disabled=\"disabled\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data, depths) {
      var stack1,
        buffer = "<div class=\"content-margin\">\n  <div> <span class=\"large-title-text decision-categories-label ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.requiredCategories : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">Categories</span> </div>\n  Select the applicable categories for this decision. &nbsp; &nbsp; \n  <div class=\"decision-categories-error input-error\">\n    <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n    <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n    <span class=\"error-message\"></span>\n  </div>\n</div>\n<ol class=\"category-list\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.categories : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(3, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</ol>";
    },
    "useData": true,
    "useDepths": true
  });
  this["RSTemplates"]["document.decision.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      return "            <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary save-decision-btn\"><i class=\"fa-icon fa-icon-save\"></i>SAVE</div>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "            <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary edit-decision-btn\"><i class=\"fa-icon fa-icon-pencil-square-o\"></i>EDIT</div>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "MEETING";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "SUBMISSION DETAILS";
    },
    "10": function _(depth0, helpers, partials, data) {
      return "content-margin";
    },
    "12": function _(depth0, helpers, partials, data) {
      return "center";
    },
    "14": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "                  <select id=\"decision-type\" class=\"form-control\" data-property=\"decisionType\">\n                    <option value=\"NaN\">None</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.decisionTypes : depth0, (stack1 = (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.decisionType : stack1) != null ? stack1.id : stack1, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                  </select>\n";
    },
    "15": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                      <option value=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "id",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, data && data.selected, {
        "name": "if",
        "hash": {},
        "fn": this.program(16, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "16": function _(depth0, helpers, partials, data) {
      return "selected";
    },
    "18": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "                  <div>";
      stack1 = helpers['if'].call(depth0, (stack1 = (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.decisionType : stack1) != null ? stack1.description : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(19, data),
        "inverse": this.program(21, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "19": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.decisionType : stack1) != null ? stack1.description : stack1, depth0));
    },
    "21": function _(depth0, helpers, partials, data) {
      return "";
    },
    "23": function _(depth0, helpers, partials, data) {
      return "style=\"display:none;\"";
    },
    "25": function _(depth0, helpers, partials, data) {
      return "padding";
    },
    "27": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                        <div class=\"input-group\">\n                          <input id=\"decision-vote-for\" type=\"text\" class=\"form-control number-control\" maxlength=\"2\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.voteFor : stack1, depth0)) + "\">\n                          <div class=\"input-group-addon increase-vote\">\n                            <i class=\"fa-icon fa-icon-chevron-up\"></i>\n                          </div>\n                          <div class=\"input-group-addon decrease-vote\">\n                            <i class=\"fa-icon fa-icon-chevron-down\"></i>\n                          </div>\n                        </div>\n";
    },
    "29": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                        " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.voteFor : stack1, depth0)) + "\n";
    },
    "31": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                        <div class=\"input-group\">\n                          <input id=\"decision-vote-against\" type=\"text\" class=\"form-control number-control\" maxlength=\"2\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.voteAgainst : stack1, depth0)) + "\">\n                          <div class=\"input-group-addon increase-vote\">\n                            <i class=\"fa-icon fa-icon-chevron-up\"></i>\n                          </div>\n                          <div class=\"input-group-addon decrease-vote\">\n                            <i class=\"fa-icon fa-icon-chevron-down\"></i>\n                          </div>\n                        </div>\n";
    },
    "33": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                        " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.voteAgainst : stack1, depth0)) + "\n";
    },
    "35": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                        <div class=\"input-group\">\n                          <input id=\"decision-vote-abstain\" type=\"text\" class=\"form-control number-control\" maxlength=\"2\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.voteAbstain : stack1, depth0)) + "\">\n                          <div class=\"input-group-addon increase-vote\">\n                            <i class=\"fa-icon fa-icon-chevron-up\"></i>\n                          </div>\n                          <div class=\"input-group-addon decrease-vote\">\n                            <i class=\"fa-icon fa-icon-chevron-down\"></i>\n                          </div>\n                        </div>\n";
    },
    "37": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                        " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.voteAbstain : stack1, depth0)) + "\n";
    },
    "39": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                  <div class=\"input-group date\">\n                    <input id=\"decision-result-date\" type=\"text\" class=\"form-control\" data-property=\"resultDate\" data-provide=\"datepicker\" data-date-autoclose=\"true\" data-date-start-view=\"1\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.displayResultDate : stack1, depth0)) + "\">\n                    <label class=\"input-group-addon\" for=\"decision-result-date\"><i class=\"fa-icon fa-icon-calendar\"></i></label>\n                  </div>\n                  <div class=\"decision-result-date-error input-error\">\n                    <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                    <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                    <span class=\"error-message\"></span>\n                  </div>\n";
    },
    "41": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "                  <div>";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.displayResultDate : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(42, data),
        "inverse": this.program(21, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "42": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.displayResultDate : stack1, depth0));
    },
    "44": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "                  <div class=\"input-group date\">\n                    <input id=\"decision-expiration-date\" ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.shouldUseExpirationDate : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(45, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " type=\"text\" class=\"form-control\" data-provide=\"datepicker\" data-date-autoclose=\"true\" data-date-start-view=\"1\" value=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.shouldUseExpirationDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(47, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\">\n                    <label for=\"decision-expiration-date\" class=\"input-group-addon\"><i class=\"fa-icon fa-icon-calendar\"></i></label>\n                  </div>\n                  <div class=\"decision-expiration-date-error input-error\">\n                    <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                    <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                    <span class=\"error-message\"></span>\n                  </div>\n";
    },
    "45": function _(depth0, helpers, partials, data) {
      return "disabled=\"disabled\"";
    },
    "47": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return escapeExpression(lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.displayExpirationDate : stack1, depth0));
    },
    "49": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "                  <div>";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.displayExpirationDate : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(50, data),
        "inverse": this.program(21, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "50": function _(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.shouldUseExpirationDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(47, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "52": function _(depth0, helpers, partials, data) {
      return "style=\"display:none\"";
    },
    "54": function _(depth0, helpers, partials, data) {
      return "                <textarea id=\"document-recused\" class=\"redactor-input\"></textarea>\n";
    },
    "56": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "                <div class=\"text-container\">\n                  ";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.recused : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(57, data),
        "inverse": this.program(21, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n                </div>\n";
    },
    "57": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda;
      stack1 = lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.recused : stack1, depth0);
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "59": function _(depth0, helpers, partials, data) {
      return "hide-section";
    },
    "61": function _(depth0, helpers, partials, data) {
      return "          <textarea id=\"document-findings\" class=\"redactor-input\"></textarea>\n";
    },
    "63": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "          <div class=\"text-container\">\n            ";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.findings : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(64, data),
        "inverse": this.program(21, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n          </div>\n";
    },
    "64": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda;
      stack1 = lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.findings : stack1, depth0);
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "66": function _(depth0, helpers, partials, data) {
      return "          <textarea id=\"decision-internal-notes\" class=\"redactor-input\" name=\"\" id=\"\" cols=\"30\" rows=\"10\"></textarea>\n";
    },
    "68": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "          <div class=\"text-container\">\n            ";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.internalNotes : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(69, data),
        "inverse": this.program(21, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n          </div>\n";
    },
    "69": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda;
      stack1 = lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.internalNotes : stack1, depth0);
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "71": function _(depth0, helpers, partials, data) {
      return "          <textarea id=\"decision-research-notes\" class=\"redactor-input\" name=\"\" id=\"\" cols=\"30\" rows=\"10\"></textarea>\n";
    },
    "73": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "          <div class=\"text-container\">\n            ";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.researchNotes : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(74, data),
        "inverse": this.program(21, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n          </div>\n";
    },
    "74": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda;
      stack1 = lambda((stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.researchNotes : stack1, depth0);
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "76": function _(depth0, helpers, partials, data) {
      return "    <div class=\"e3-table-tight content-table-padding-lg\">\n      <div class=\"content-margin content-padding-lg\">\n        <h2 class=\"no-margin\">Letters</h2>\n      </div>\n      <div class=\"letter-table-container\"></div>\n    </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content-page-width full-height clearfix\">\n\n  <div class=\"content-header content-underline content-page-width\">\n    <div class=\"navigation-header\">\n      <div class=\"pull-right content-padding-top\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.editable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      </div>\n      <div class=\"rs-navigation-previous\">\n        <span class=\"glyphicon glyphicon-chevron-left\"></span> ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.fromMeetingView : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.program(8, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n      </div>\n      <div class=\"rs-navigation-divider\"></div>\n      <div class=\"rs-navigation-title\">\n        <div style=\"margin-top: 5px; margin-bottom: -5px;\">IRB NUMBER: <strong>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.document : stack1) != null ? stack1.studyLabel : stack1, depth0)) + "</strong></div>\n        <h2 class=\"no-margin\" style=\"line-height: normal;\">Decision for " + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.document : stack1) != null ? stack1.studyTitle : stack1, depth0)) + " - " + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.decision : depth0) != null ? stack1.document : stack1) != null ? stack1.templateType : stack1, depth0)) + "</h2>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"content-body content-padding-lg content-padding-top-xl e3-table-tight content-table-padding-lg\">\n    <div class=\"content-margin-large\">\n      <div class=\"row\">\n        <div class=\"col-sm-5\">\n          <div class=\"content-margin\">\n            <h2 class=\"no-margin\">Results</h2>\n          </div>\n          <div class=\"results-container\">\n\n            <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n              <label for=\"decision-decision\" class=\"control-label ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " col-sm-3 text-right\">Decision:</label>\n              <div class=\"col-sm-9\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.program(18, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "              </div>\n            </div>\n\n            <div ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.usesVotes : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(23, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " class=\"row\">\n              <label class=\"control-label ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " col-md-3 text-right\">Votes:</label>\n              <div class=\"col-md-9\">\n                <div class=\"votes-container\">\n                  <div class=\"row vote-header-row\">\n                    <div class=\"col-xs-4 vote-header-cell\">For</div>\n                    <div class=\"col-xs-4 vote-header-cell\">Against</div>\n                    <div class=\"col-xs-4 vote-header-cell\">Abstain</div>\n                  </div>\n                  <div class=\"row text-center vote-input-row\">\n                    <div class=\"col-xs-4 vote-input-cell ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(27, data),
        "inverse": this.program(29, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                    </div>\n                    <div class=\"col-xs-4 vote-input-cell ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(31, data),
        "inverse": this.program(33, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                    </div>\n                    <div class=\"col-xs-4 vote-input-cell ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(35, data),
        "inverse": this.program(37, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n\n            <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n              <label for=\"decision-result-date\" class=\"decision-result-date-label control-label ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " col-sm-3 text-right\">Result:</label>\n              <div class=\"col-sm-9\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(39, data),
        "inverse": this.program(41, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "              </div>\n            </div>\n\n            <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n              <label for=\"decision-expiration-date\" class=\"decision-expiration-date-label control-label ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " col-sm-3 text-right\">Expiration:</label>\n              <div class=\"col-sm-9\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(44, data),
        "inverse": this.program(49, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "              </div>\n            </div>\n\n          </div>\n        </div>\n        <div class=\"col-sm-7\">\n          <div ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.usesRecused : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(52, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " class=\"content-margin-large\">\n\n            <div class=\"content-margin-large\">\n              <div class=\"content-margin\">\n                <h2 class=\"no-margin\">Recused</h2>\n              </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(54, data),
        "inverse": this.program(56, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"content-margin-large categories-section ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.usesCategories : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(59, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n";
      stack1 = this.invokePartial(partials['document.decision.categories'], '      ', 'document.decision.categories', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n\n    <div class=\"content-margin-large\">\n      <div class=\"content-margin\">\n        <h2 class=\"no-margin\">Findings</h2>\n        Information entered here can be used as part of the correspondence with the tag [findings].\n      </div>\n      <div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(61, data),
        "inverse": this.program(63, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      </div>\n    </div>\n\n    <div class=\"content-margin-large\">\n      <div class=\"content-margin\">\n        <h2 class=\"no-margin\">Notes for Internal Use</h2>\n      </div>\n      <div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(66, data),
        "inverse": this.program(68, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      </div>\n    </div>\n\n    <div class=\"content-margin-large\">\n      <div class=\"content-margin\">\n        <h2 class=\"no-margin\">Notes for Research Team</h2>\n        Information entered here can be used as part of the correspondence with the tag [research-team-notes].\n      </div>\n      <div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(71, data),
        "inverse": this.program(73, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      </div>\n    </div>\n\n  </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.letters : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(76, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n  <div class=\"clearfix\"></div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["document.diff.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"document-diff-container\">\n	<div class=\"content-header content-margin content-underline\">\n\n\n		<div class=\"navigation-header content-padding clearfix content-underline\">\n			<div class=\"pull-right form-section-navigation\">\n				<div role=\"button\" tabindex=\"0\" class=\"btn btn-default\" data-section-nav=\"previous\" title=\"Previous Section\"><span class=\"fa-icon fa-icon-chevron-left\"></span></div>\n				<div role=\"button\" tabindex=\"0\" class=\"btn btn-default\" data-section-nav=\"next\" title=\"Next Section\"><span class=\"fa-icon fa-icon-chevron-right\"></span></div>\n			</div>\n\n			<div role=\"button\" tabindex=\"0\" class=\"rs-navigation-previous\">\n			  <span class=\"glyphicon glyphicon-chevron-left\"></span>\n			  VIEW SUBMISSION\n			</div>\n			<div class=\"rs-navigation-divider light\"></div>\n			<div class=\"rs-navigation-title\">\n			  <div class=\"large-title-text\">\n			    Comparison: <span class=\"form-diff-document-title\"></span>\n			  </div>\n			</div>\n		</div>\n		<div class=\"clearfix\"></div>\n		<div class=\"content-margin content-padding content-toolbar diff-panel-header-container\">\n			<div class=\"row diff-panel-header\">\n				<div class=\"col-xs-6 previous-submission\">\n					PREVIOUS SUBMISSION\n					<select class=\"document-selector\">\n						<option value='prev-doc'>Previously Approved Submission</option>\n						<option value='same-doc'>Previously Certified Revision</option>\n					</select>\n				</div>\n				<div class=\"col-xs-6 current-submission\">\n					CURRENT SUBMISSION\n				</div>\n                <div role=\"button\" tabindex=\"0\" class=\"attachment-diff-viewer-close\">\n                    <i class=\"fa-icon fa-icon-times\"></i>\n                </div>\n			</div>\n		</div>\n\n	</div>\n\n	<div class=\"content-body form-container\">\n			<nav class=\"form-diff-sidebar\" aria-labelledby=\"sidebarHeader\" aria-controls=\"diffContainer\">\n				<div role=\"button\" tabindex=\"0\" class=\"form-diff-sidebar-closer\"><span class=\"fa-icon fa-icon-chevron-left\"></span></div>\n				<div class=\"form-diff-sidebar-scroller\">\n					<div id=\"sidebarHeader\" role=\"heading\" level=\"3\" class=\"form-sidebar-header\">Sections</div>\n				</div>\n			</nav>\n\n			<div id=\"diffControls\" class=\"form-diff-controls content-underline text-center\" aria-label=\"navigate comparisons\" aria-controls=\"diffContainer\">\n				<div id=\"previousDiffButton\" role=\"button\" tabindex=\"0\" class=\"form-diff-control\" aria-label=\"previous comparison\" data-action=\"previous\"><span class=\"fa-icon fa-icon-arrow-left pull-left\"></span>Previous diff</div>\n				<div id=\"nextDiffButton\" role=\"button\" tabindex=\"0\" class=\"form-diff-control\" aria-label=\"next comparison\" data-action=\"next\"><span class=\"fa-icon fa-icon-arrow-right pull-right\"></span>Next diff</div>\n				<span class=\"form-diffs-count badge\"></span>\n			</div>\n\n			<div tabindex=\"0\" class=\"empty-form\">\n				<span>There are no previous answers to compare.</span>\n			</div>\n			<div id=\"diffContainer\" class=\"form-diff-container\">\n				<div class=\"diff-highlight-container\"></div>\n				<div class=\"diff-wrapper left\">\n					<div class=\"form-container-left\">\n					</div>\n				</div>\n				<div class=\"form-diff-spacer-wrapper\">\n					<div class=\"form-diff-spacer\"></div>\n				</div>\n				<div class=\"diff-wrapper right\">\n					<div class=\"form-container-right\">\n					</div>\n				</div>\n			</div>\n			<div class=\"diff-iframe-container\">\n			    <iframe class=\"attachment-diff-iframe\"></iframe>\n			</div>\n\n	</div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["comments.popover"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.comments : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"popover-comment list-group-item\" data-template-id=\"" + escapeExpression((helper = (helper = helpers.templateObjectId || (depth0 != null ? depth0.templateObjectId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "templateObjectId",
          "hash": {},
          "data": data
        }) : helper)) + "\">\n          <div class=\"comment-text\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n        </div>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "      All comments have been addressed or resolved.\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div>\n  <div class=\"popover-header\">\n    <span>Unaddressed Comments</span>\n  </div>\n  <div class=\"popover-list popover-comments list-group\">\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.comments : depth0) != null ? stack1.length : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["document.details.pdf"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing;
      return "<div class=\"pdf-header clearfix\">\n  <div class=\"pull-left\">\n    <img class=\"header-logo\" src=\"data:image/png;base64,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\"/>\n  </div>\n  <div class=\"pull-right header-info\">\n    <span class=\"sub-heading\">Submission Type:</span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.doc : depth0) != null ? stack1.templateType : stack1, depth0)) + "\n    <span class=\"sub-heading\">Date:</span>" + escapeExpression((helper = (helper = helpers.date || (depth0 != null ? depth0.date : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "date",
        "hash": {},
        "data": data
      }) : helper)) + "\n  </div>\n</div>\n<div class=\"pdf-body\">\n  <div class=\"sub-header\" style=\"padding:0px; border: 0px;\">\n    <div class=\"text-left default-color\">\n      <span class=\"sub-heading\">IRB #:</span><span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.doc : depth0) != null ? stack1.studyLabel : stack1, depth0)) + "</span></br>\n      <span class=\"sub-heading\">Title:</span><span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.doc : depth0) != null ? stack1.studyTitle : stack1, depth0)) + "</span></br>\n      <span class=\"sub-heading\">Creation Date:</span>" + escapeExpression((helper = (helper = helpers.createDate || (depth0 != null ? depth0.createDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "createDate",
        "hash": {},
        "data": data
      }) : helper)) + "<br/>\n      <span class=\"sub-heading\">Status:</span><span class=\"highlight\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper)) + "</span><br/>\n      <span class=\"sub-heading\">Principal Investigator:</span>" + escapeExpression(lambda((stack1 = (stack1 = (stack1 = (stack1 = depth0 != null ? depth0.assignments : depth0) != null ? stack1.PRINCIPAL_INVESTIGATOR : stack1) != null ? stack1['0'] : stack1) != null ? stack1.person : stack1) != null ? stack1.displayName : stack1, depth0)) + "\n    </div>\n  </div>\n  <div class=\"pdf-form-container\"></div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["document.edit.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"form-container\">\n  \n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["document.letter.detail"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"form-update-letter content-form\">\n\n    <div class=\"row content-margin\">\n      <div class=\"col-sm-6\">\n        <div>\n          <label><i class=\"required\">*</i>&nbsp; Subject:</label>\n        </div>\n        <input class=\"letter-subject-update form-control\" type=\"text\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.item : depth0) != null ? stack1.subject : stack1, depth0)) + "\" />\n        <div class=\"letter-subject-update-error input-error margin-top\">\n          <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n          <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n          <span class=\"error-message\"></span>\n        </div>\n      </div>\n      <div class=\"col-sm-6\">\n        <div>\n          <label for=\"\"><i class=\"required\">*</i>&nbsp; Recipients:</label>\n        </div>\n        <input type=\"text\" class=\"letter-recipients-update form-control\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.item : depth0) != null ? stack1.recipients : stack1, depth0)) + "\">\n        <div class=\"letter-recipients-update-error input-error margin-top\">\n          <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n          <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n          <span class=\"error-message\"></span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row content-margin\">\n      <div class=\"col-sm-6\">\n        <label>CC:</label>\n        <input class=\"letter-cc-update form-control\" type=\"text\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.item : depth0) != null ? stack1.cc : stack1, depth0)) + "\" />\n        ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "letter-cc-update"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n      </div>\n      <div class=\"col-sm-6\">\n        <div>\n          <label for=\"\">BCC:</label>\n        </div>\n        <input type=\"text\" class=\"letter-bcc-update form-control\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.item : depth0) != null ? stack1.bcc : stack1, depth0)) + "\">\n        ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "letter-bcc-update"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row content-margin\">\n      <div class=\"col-sm-12\">\n        <label><i class=\"required\">*</i>&nbsp; Letter Content:</label>\n        <textarea class=\"letter-content-update\"></textarea>\n        <div class=\"letter-content-update-error input-error margin-top\">\n          <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n          <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n          <span class=\"error-message\"></span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <span class=\"required\"><i class=\"required\">*</i>&nbsp; - Required</span>\n        <div class=\"pull-right \">\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-delete-update-letter\"><i class=\"fa-icon fa-icon-trash-o\"></i> DELETE</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-cancel-update-letter\"><i class=\"fa-icon fa-icon-ban\"></i> Cancel</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-pdf-update\"><i class=\"fa-icon fa-icon-file\"></i>Preview PDF</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-save-update-letter\"><i class=\"fa-icon fa-icon-save\"></i> Save</div>\n        </div>\n      </div>\n    </div>\n\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["document.letter.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <option value=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"clearfix content-underline content-header content-page-width\">\n    <div class=\"navigation-header\">\n      <div class=\"content-padding-top pull-right\">\n        <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-create-letter\"><i class=\"fa-icon fa-icon-plus\"></i>Create New Letter</div>\n      </div>\n\n      <div class=\"rs-navigation-previous\">\n        <span class=\"glyphicon glyphicon-chevron-left\"></span>SUBMISSION DETAILS\n      </div>\n      <div class=\"rs-navigation-divider\"></div>\n      <div class=\"rs-navigation-title\">\n        <div style=\"margin-top: 5px; margin-bottom: -5px;\">IRB NUMBER: <strong>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.studyLabel : stack1, depth0)) + "</strong></div>\n        <div class=\"large-title-text\" style=\"line-height: normal;\">Letters for " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.studyTitle : stack1, depth0)) + " - " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.templateType : stack1, depth0)) + "</div>\n      </div>\n    </div>\n  </div>\n  <div class=\"content-body\">\n    <div class=\"form-new-letter content-form rs-hide\">\n      <div class=\"content-padding content-padding-top content-padding-bottom\">\n        <div class=\"header clearfix\">\n          <span class=\"large-title-text pull-left\">Creating a New Letter</span>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <label><i class=\"required\">*</i> Letter Template:</label>\n            <select class=\"letter-type-create form-control\">\n              <option value=\"\">Select a Template Type</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.templateTypes : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "            </select>\n            <div class=\"letter-type-create-error input-error margin-top\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n          <div class=\"col-sm-6\">\n            <label><i class=\"required\">*</i> Subject:</label>\n            <input class=\"letter-subject-create form-control\" type=\"text\" />\n            <div class=\"letter-subject-create-error input-error margin-top\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <label><i class=\"required\">*</i> Recipients:</label>\n            <input class=\"letter-recipients-create form-control\" type=\"text\" />\n            <div class=\"letter-recipients-create-error input-error margin-top\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <label>CC:</label>\n            <input class=\"letter-cc-create form-control\" type=\"text\" />\n            <div class=\"letter-cc-create-error input-error margin-top\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n\n          <div class=\"col-sm-6\">\n            <label>BCC:</label>\n            <input class=\"letter-bcc-create form-control\" type=\"text\" />\n            <div class=\"letter-bcc-create-error input-error margin-top\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n        </div>\n\n\n        <div class=\"row content-margin\">\n          <div class=\"col-sm-12\">\n            <label><i class=\"required\">*</i> Letter Content:</label>\n            <textarea class=\"letter-content-create redactor-input\"></textarea>\n            <div class=\"letter-content-create-error input-error margin-top\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <span class=\"required\"><i class=\"required\">*</i> - Required</span>\n            <div class=\"pull-right top-buttons\">\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-cancel-create-letter\"><i class=\"fa-icon fa-icon-ban\"></i>CANCEL</div>\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-pdf-create\"><i class=\"fa-icon fa-icon-file\"></i>Preview PDF</div>\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-save-create-letter\"><i class=\"fa-icon fa-icon-save\"></i>SAVE</div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"letter-list-container\">\n      <div class=\"letter-list-grid-container use-highlight use-selected-carrot\"></div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["new.document.modal"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing;
      return "        <option value=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">" + escapeExpression((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "type",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "        <option value=\"\">No Published Templates</option>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"modal-section-row row last\">\n  <label class=\"col-md-3 normalize text-right\"><i class=\"glyphicon glyphicon-asterisk required\"></i> Type:</label>\n  <div class=\"col-md-9\">\n    <select class=\"new-document-template-type col-md-12 form-control\">\n      <option value=\"\">Select Type</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.templates : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </select>\n    <div class=\"template-type-error input-error\">\n      <span class=\"error-close right\"><i class=\"fa-icon-times\"></i></span>\n      <div class=\"error-icon pull-left\"><i class=\"fa-icon-exclamation-circle\"></i></div>\n      <span class=\"error-message\"></span>\n    </div>\n  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["legacy.pdf.results"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "    <div style=\"padding: 10px 0px;\">" + escapeExpression(lambda(depth0, depth0)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<div style=\"margin-bottom: 20px;\">\n  <div style=\"border-bottom: 1px solid rgb(58,58,58)\">\n    <span><strong>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.results : depth0) != null ? stack1.length : stack1, depth0)) + "</strong> " + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "description",
          "hash": {},
          "data": data
        }) : helper)) + "</span>\n  </div>\n  <div>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.results : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["legacy.result.group"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <span role=\"button\" tabindex=\"0\" class=\"result-details-btn pull-right\"><i class=\"fa-icon fa-icon-caret-right pull-right\"></i>View Details</span>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "    <div class=\"result-record\">" + escapeExpression(lambda(depth0, depth0)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"result-group\">\n  <div class=\"result-description\">\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.results : depth0) != null ? stack1.length : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      <span><strong>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.results : depth0) != null ? stack1.length : stack1, depth0)) + "</strong> " + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n  </div>\n\n  <div class=\"result-details\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.results : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["legacy.upload.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        helperMissing = helpers.helperMissing,
        functionType = "function",
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"clearfix content-margin content-padding content-underline padding content-header content-page-width\">\n    <div class=\"rs-header-title\">\n      <span class=\"large-title-text\">Legacy Upload";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "help.anchor", {
        "name": "inject",
        "hash": {
          'help': depth0 != null ? depth0.mainHelp : depth0
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</span>\n    </div>\n  </div>\n  <div class=\"content-body content-padding\">\n\n    <div class=\"text-center\" style=\"display:table; width: 100%\">\n      <div class=\"upload-wizard-breadcrumb\">\n        <div class=\"wizard-nav activated\" data-wizard-step=\"upload\">\n          <div class=\"nav-text\"><span class=\"nav-label\">1.</span>Upload .CSV File</div>\n        </div>\n        <div class=\"wizard-nav\" data-wizard-step=\"results\">\n          <div class=\"nav-text\"><span class=\"nav-label\">2.</span>Validate and Submit</div>\n        </div>\n        <div class=\"wizard-nav\" data-wizard-step=\"submitted\">\n          <div class=\"nav-text\"><span class=\"nav-label\">3.</span>Submitted</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"upload-wizard-content\">\n      <div class=\"wizard-pane active\" data-wizard-pane=\"upload\">\n        <div class=\"drop-zone\">\n          <div>Drop your file here to upload</div>\n          <div>- or -</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-default\" style=\"position:relative\">Choose File";
      stack1 = this.invokePartial(partials['hidden.fileinput'], '', 'hidden.fileinput', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n          <div class=\"clearfix\">\n            <div class=\"dropped-file\">\n              <i class=\"fa-icon fa-icon-times pull-right\"></i><i class=\"fa-icon fa-icon-cloud-upload pull-left\"></i><span class=\"file-name\"></span>\n            </div>\n          </div>\n        </div>\n        <div class=\"pull-right\">\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-default disabled\" data-wizard-action=\"ValidateFile\"><i class=\"fa-icon fa-icon-arrow-circle-right pull-right\"></i>Next</div>\n        </div>\n      </div>\n      <div class=\"wizard-pane\" data-wizard-pane=\"results\">\n        <div class=\"content-margin-medium\">\n          <a role=\"button\" tabindex=\"0\" class=\"btn btn-default pull-right\" href=\"" + escapeExpression((helper = (helper = helpers.downloadLink || (depth0 != null ? depth0.downloadLink : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "downloadLink",
        "hash": {},
        "data": data
      }) : helper)) + "\">Export Results</a>\n          <div style=\"font-size: 20px;\">View Legacy Study Data Results</div>\n          <span>Click View Details to expand results within each group. Submit to proceed with the following results.</span>\n        </div>\n\n        <div class=\"content-margin-medium\">\n          <div class=\"legacy-validation-results\"></div>\n          <div class=\"legacy-results-count text-right\"></div>\n        </div>\n\n        <div class=\"clearfix\">\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-default pull-right content-margin-left\" data-wizard-action=\"SubmitFile\"><i class=\"fa-icon fa-icon-arrow-circle-right pull-right\"></i>Submit</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-default pull-left\" data-wizard-action=\"ReturnToUpload\"><i class=\"fa-icon fa-icon-arrow-circle-left pull-left\"></i>Back</div>\n        </div>\n      </div>\n      <div class=\"wizard-pane\" data-wizard-pane=\"submitted\">\n\n        <div class=\"text-center wizard-success-msg\"><i class=\"fa-icon fa-icon-check green-font-color\"></i> Successfully Submitted Legacy Study Data</div>\n\n        <div class=\"text-center content-margin-medium\">\n          <a role=\"button\" tabindex=\"0\" class=\"btn btn-default\" href=\"" + escapeExpression((helper = (helper = helpers.downloadLink || (depth0 != null ? depth0.downloadLink : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "downloadLink",
        "hash": {},
        "data": data
      }) : helper)) + "\">Export Results</a>\n        </div>\n\n        <div class=\"text-center\">\n          <span role=\"button\" tabindex=\"0\" class=\"btn btn-link\" data-wizard-action=\"NavigateToStudies\">Go to Studies</span>\n        </div>\n\n      </div>\n    </div>\n\n  </div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["letter.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "disabled=\"disabled\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <option value=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "id",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, data && data.selected, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "selected";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "checked";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "no-modify";
    },
    "10": function _(depth0, helpers, partials, data) {
      return "<div role=\"button\" tabindex=\"0\" class=\"btn btn-rs danger wide-view btn-delete-update-letter\"><i class=\"fa-icon fa-icon-trash-o pull-right\"></i> DELETE</div>";
    },
    "12": function _(depth0, helpers, partials, data) {
      return "<div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-save-update-letter\"><i class=\"fa-icon fa-icon-save pull-right\"></i> SAVE</div>";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"row\">\n  <div class=\"form-update-letter content-form content-padding\">\n    <div class=\"form-container\">\n      <div class=\"header clearfix\">\n        <span class=\"large-title-text pull-left\">Updating a Letter</span>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-5\">\n          <label><i class=\"required\">*</i> Letter Name:</label>\n          <input ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " class=\"letter-name form-control\" type=\"text\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.letter : depth0) != null ? stack1.name : stack1, depth0)) + "\" />\n          <div class=\"letter-name-error input-error\">\n            <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n            <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n            <span class=\"error-message\"></span>\n          </div>\n        </div>\n        <div class=\"col-sm-5\">\n          <label><i class=\"required\">*</i> Submission Type:</label>\n          <select ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " class=\"letter-type form-control\">\n            <option value=\"\">Select a Template Type</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.templateTypes : depth0, (stack1 = (stack1 = depth0 != null ? depth0.letter : depth0) != null ? stack1.templateType : stack1) != null ? stack1.id : stack1, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </select>\n          <div class=\"letter-type-error input-error\">\n            <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n            <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n            <span class=\"error-message\"></span>\n          </div>\n        </div>\n        <div class=\"col-sm-2\">\n          <label>Active:</label>\n          <div data-class-bool=\"checked\" class=\"";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.letter : depth0) != null ? stack1.active : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " checkbox-custom letter-active-flg ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\"></div>\n        </div>\n      </div>\n      <div class=\"row content-margin\">\n        <div class=\"col-sm-12\">\n          <label><i class=\"required\">*</i> Letter Content:</label>\n          <textarea ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " class=\"letter-content\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.letter : depth0) != null ? stack1.content : stack1, depth0)) + "</textarea>\n          <div class=\"letter-content-error input-error\">\n            <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n            <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n            <span class=\"error-message\"></span>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <span class=\"required\"><i class=\"required\">*</i> - Required</span>\n          <div class=\"pull-right \">\n            ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.deletePermission : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n            <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-cancel-update-letter\"><i class=\"fa-icon fa-icon-ban pull-right\"></i> CANCEL</div>\n            <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-create-pdf\"><i class=\"fa-icon fa-icon-file pull-right\"></i>Preview</div>\n            ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["letter.list.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-create-letter pull-right\"><i class=\"fa-icon fa-icon-plus pull-right\"></i>Create Letter Template</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <option value=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"clearfix content-underline padding content-header content-padding content-page-width\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canCreate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    <div class=\"rs-header-title\">\n      <span class=\"large-title-text\">Manage Letter Templates</span>\n    </div>\n  </div>\n  <div class=\"content-body\">\n    <div class=\"form-new-letter content-form\">\n      <div class=\"form-container\">\n        <div class=\"header clearfix\">\n          <span class=\"large-title-text pull-left\">Creating a New Letter</span>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-5\">\n            <label><i class=\"required\">*</i> Title:</label>\n            <input class=\"letter-name form-control\" type=\"text\" />\n            <div class=\"letter-name-error input-error\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n          <div class=\"col-sm-5\">\n            <label><i class=\"required\">*</i> Submission Type:</label>\n            <select class=\"letter-type form-control\">\n              <option value=\"\">Select a Template Type</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.templateTypes : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "            </select>\n            <div class=\"letter-type-error input-error\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            <label>Active:<br /></label>\n            <div data-class-bool=\"checked\" class=\"checkbox-custom letter-active-flg\"></div>\n          </div>\n        </div>\n        <div class=\"row content-margin\">\n          <div class=\"col-sm-12\">\n            <label><i class=\"required\">*</i> Letter Content:</label>\n            <textarea class=\"letter-content\"></textarea>\n            <div class=\"letter-content-error input-error\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <span class=\"required\"><i class=\"required\">*</i> - Required</span>\n            <div class=\"pull-right top-buttons\">\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-cancel-create-letter\"><i class=\"fa-icon fa-icon-ban pull-right\"></i>CANCEL</div>\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-save-create-letter\"><i class=\"fa-icon fa-icon-save pull-right\"></i>SAVE</div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content-body letter-list-container\">\n      <div class=\"content-bar-dark\">\n        <div class=\"rs-filter-group pull-right\" style=\"margin-bottom: 5px;\">\n          <i class=\"fa-icon fa-icon-search\"></i>\n          <input type=\"text\" class=\"filter-input\" placeholder=\"Filter\" />\n          <i class=\"fa-icon fa-icon-times-circle filter-clear pull-right\"></i>\n        </div>\n      </div>\n      <div class=\"letter-list-grid-container use-highlight use-selected-carrot\"></div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["meeting.detail.header"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary create-meeting-btn\"><i class=\"fa-icon fa-icon-save\"></i>CREATE</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.program(6, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "4": function _(depth0, helpers, partials, data) {
      return "        <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs cancel-edit-btn\"><i class=\"fa-icon fa-icon-times-circle\"></i>CANCEL</div>\n        <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary save-meeting-btn wide-view\"><i class=\"fa-icon fa-icon-save\"></i>SAVE</div>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canDelete : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canEdit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "7": function _(depth0, helpers, partials, data) {
      return "          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs danger delete-meeting-btn wide-view\"><i class=\"fa-icon fa-icon-times\"></i>DELETE</div>\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      return "          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs edit-meeting-btn wide-view\"><i class=\"fa-icon fa-icon-pencil-square-o\"></i>EDIT</div>\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      return "        Create Meeting\n";
    },
    "13": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.name : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.program(16, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "14": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "          Meeting: " + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "16": function _(depth0, helpers, partials, data) {
      return "          Meeting Details\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"navigation-header\">\n\n  <div class=\"pull-right content-padding-top\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.create : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  </div>\n\n  <div class=\"rs-navigation-previous\">\n    <span class=\"glyphicon glyphicon-chevron-left\"></span>CALENDAR\n  </div>\n  <div class=\"rs-navigation-divider light\"></div>\n  <div class=\"rs-navigation-title\">\n    <span class=\"large-title-text\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.create : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.program(13, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </span>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["meeting.detail.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "non-editable";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"content-page-width full-height content-table-padding-lg e3-table-tight\">\n\n  <div class=\"clearfix content-underline content-header content-page-width\"></div>\n\n  <div class=\"content-padding-top-xl\">\n    <div class=\"content-margin-large\">\n      <div class=\"meeting-details-table\"></div>\n    </div>\n\n    <div class=\"content-margin-large\">\n      <div class=\"content-margin content-padding-lg\">\n        <div class=\"pull-right\" style=\"margin-top: -11px;\">\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view add-person-btn\"><i class=\"fa-icon fa-icon-plus-circle pull-right\"></i>ADD ATTENDEE</div>\n        </div>\n        <h2 class=\"no-margin content-indent-marker\">Attendees</h2>\n      </div>\n      <div class=\"meeting-person-container use-side-highlight ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></div>\n    </div>\n\n    <div class=\"content-margin-large\">\n      <div class=\"content-margin content-padding-lg\">\n        <div class=\"pull-right\" style=\"margin-top: -11px;\">\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs add-submission-btn wide-view\"><i class=\"fa-icon fa-icon-plus-circle pull-right\"></i>ADD SUBMISSION</div>\n        </div>\n        <h2 class=\"no-margin content-indent-marker\">Full Board Reviews</h2>\n      </div>\n      <div class=\"meeting-document-container use-highlight use-selected-carrot e3-table-sm-responsive\"></div>\n    </div>\n\n\n\n    <div class=\"expedited-decisions-section content-margin-large\">\n      <div class=\"content-margin content-padding-lg\">\n        <h2 class=\"no-margin content-indent-marker\">Expedited</h2>\n      </div>\n      <div class=\"expedited-decisions-container e3-table-sm-responsive\"></div>\n    </div>\n\n    <div class=\"exempt-decisions-section\">\n      <div class=\"content-margin content-padding-lg\">\n        <h2 class=\"no-margin content-indent-marker\">Exemptions</h2>\n      </div>\n      <div class=\"exempt-decisions-container e3-table-sm-responsive\"></div>\n    </div>\n\n    <div class=\"clearfix\"></div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["meeting.detail.table"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "edit-mode";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "view-mode";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "content-margin";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "<span class=\"required\">*</span>";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <div class=\"input-group date\">\n                <input id=\"meeting-start-date\" type=\"text\" class=\"form-control\" data-provide=\"datepicker\" data-date-autoclose=\"true\" data-date-start-view=\"1\" value=\"" + escapeExpression((helper = (helper = helpers.startDate || (depth0 != null ? depth0.startDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "startDate",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">\n                <span class=\"input-group-addon\"><i class=\"fa-icon fa-icon-calendar\"></i></span>\n              </div>\n              <div class=\"meeting-start-date-error input-error\">\n                <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                <span class=\"error-message\"></span>\n              </div>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "12": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              " + escapeExpression((helper = (helper = helpers.startDate || (depth0 != null ? depth0.startDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "startDate",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "14": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <div class=\"input-group bootstrap-timepicker\">\n                <input id=\"meeting-start-time\" type=\"text\" class=\"form-control\" value=\"" + escapeExpression((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "startTime",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n                <span class=\"input-group-addon\"><i class=\"fa-icon fa-icon-clock-o\"></i></span>\n              </div>\n              <div class=\"meeting-start-time-error input-error\">\n                <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                <span class=\"error-message\"></span>\n              </div>\n";
    },
    "16": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              " + escapeExpression((helper = (helper = helpers.startTime || (depth0 != null ? depth0.startTime : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "startTime",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "18": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <div class=\"input-group bootstrap-timepicker\">\n                <input id=\"meeting-end-time\" type=\"text\" class=\"form-control\" value=\"" + escapeExpression((helper = (helper = helpers.endTime || (depth0 != null ? depth0.endTime : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "endTime",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n                <span class=\"input-group-addon\"><i class=\"fa-icon fa-icon-clock-o\"></i></span>\n              </div>\n              <div class=\"meeting-end-time-error input-error\">\n                <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                <span class=\"error-message\"></span>\n              </div>\n";
    },
    "20": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              " + escapeExpression((helper = (helper = helpers.endTime || (depth0 != null ? depth0.endTime : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "endTime",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "22": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <input id=\"meeting-location\" type=\"text\" class=\"form-control\" value=\"" + escapeExpression((helper = (helper = helpers.location || (depth0 != null ? depth0.location : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "location",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">\n              <div class=\"meeting-location-error input-error\">\n                <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                <span class=\"error-message\"></span>\n              </div>\n";
    },
    "24": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              " + escapeExpression((helper = (helper = helpers.location || (depth0 != null ? depth0.location : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "location",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "26": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "              <select class=\"form-control meeting-board-selection\" ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n                <option value=\"\">None</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.boards : depth0, (stack1 = depth0 != null ? depth0.board : depth0) != null ? stack1.id : stack1, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(27, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "              </select>\n              <div class=\"meeting-board-error input-error\">\n                <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                <span class=\"error-message\"></span>\n              </div>\n";
    },
    "27": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "                  <option value=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" ";
      stack1 = helpers['if'].call(depth0, data && data.selected, {
        "name": "if",
        "hash": {},
        "fn": this.program(28, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "28": function _(depth0, helpers, partials, data) {
      return "selected";
    },
    "30": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "              " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.board : depth0) != null ? stack1.name : stack1, depth0)) + "\n";
    },
    "32": function _(depth0, helpers, partials, data) {
      return "              <textarea class=\"form-control no-resize\" id=\"meeting-agenda\" rows=\"12\"></textarea>\n              <div class=\"meeting-agenda-error input-error\">\n                <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n                <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n                <span class=\"error-message\"></span>\n              </div>\n";
    },
    "34": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "              <div class=\"meeting-agenda-viewer\">\n                ";
      stack1 = (helper = (helper = helpers.agenda || (depth0 != null ? depth0.agenda : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "agenda",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n              </div>\n";
    },
    "36": function _(depth0, helpers, partials, data) {
      return "    <div class=\"\">\n      <span class=\"required\">* - Required</span>\n    </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "\n\n<div class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " content-padding-lg content-body\">\n  <div class=\"\">\n    <div class=\"row\">\n      <div class=\"col-md-4\">\n        \n        <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n          <div class=\"col-sm-4 text-right\">\n            <label for=\"meeting-start-date\" class=\"\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " Date:</label>\n          </div>\n          <div class=\"col-sm-8\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.program(12, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n        <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n          <div class=\"col-sm-4 text-right\"><label for=\"meeeting-start-time\" class=\"\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " Start Time:</label></div>\n          <div class=\"col-sm-8\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.program(16, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n        <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n          <div class=\"col-sm-4 text-right\"><label for=\"meeting-end-time\" class=\"\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " End Time:</label></div>\n          <div class=\"col-sm-8\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(18, data),
        "inverse": this.program(20, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n        <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n          <div class=\"col-sm-4 text-right\"><label for=\"meeting-location\" class=\"\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " Location:</label></div>\n          <div class=\"col-sm-8\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(22, data),
        "inverse": this.program(24, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n        <div class=\"row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n          <div class=\"col-sm-4 text-right\"><label class=\"\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " Board:</label></div>\n          <div class=\"col-sm-8\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(26, data),
        "inverse": this.program(30, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n      </div>\n      <div class=\"col-md-8\">\n        <div class=\"row\">\n          <div class=\"col-sm-2 text-right\">\n            <label for=\"meeting-agenda\" class=\"\">Agenda:</label>\n          </div>\n          <div class=\"col-sm-10\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(32, data),
        "inverse": this.program(34, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(36, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["meeting.document.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view make-decision-btn\"><i class=\"fa-icon fa-icon-gavel pull-right\"></i> Make Decision</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "    <div class=\"content-padding content-padding-top content-padding-bottom previous-notes-header\" style=\"background-color: #262626;\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <span class=\"md-title-text\">Previous Notes &nbsp; &nbsp;<i class=\"fa-icon fa-icon-chevron-down\"></i><i class=\"fa-icon fa-icon-chevron-right\"></i></span>\n        </div>\n      </div>\n    </div>\n    <div class=\"meeting-document-notes-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.notes : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = this.invokePartial(partials['meeting.note'], '        ', 'meeting.note', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"meeting-document-detail\">\n  <div class=\"\">\n    <textarea cols=\"30\" rows=\"10\" class=\"form-control-dark no-resize\"></textarea>\n  </div>\n  <div class=\"clearfix content-padding-left content-padding-right content-padding-bottom content-padding-top header-two-bg-color\">\n    <div class=\"pull-right\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.openDecision : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view open-study-btn\"><i class=\"fa-icon fa-icon-external-link\"></i>Study</div>\n      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view save-notes-btn\"><i class=\"fa-icon fa-icon-save\"></i> Save</div>\n    </div>\n  </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.notes : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["meeting.event.details"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <div class=\"meeting-list-navigation\">\n    <span class=\"glyphicon glyphicon-chevron-left\"></span>\n    Meetings List\n  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"meeting-list-row\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.list : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  <div>\n    <strong>Board: </strong> " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.original : depth0) != null ? stack1.title : stack1, depth0)) + "\n  </div>\n  <div>\n    <strong>Date:</strong> " + escapeExpression((helpers.dateFormat || depth0 && depth0.dateFormat || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.original : depth0) != null ? stack1.startDate : stack1, {
        "name": "dateFormat",
        "hash": {
          'format': "MM/DD/YYYY"
        },
        "data": data
      })) + "\n  </div>\n  <div>\n    <strong>Time: </strong> " + escapeExpression((helpers.dateFormat || depth0 && depth0.dateFormat || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.original : depth0) != null ? stack1.startDate : stack1, {
        "name": "dateFormat",
        "hash": {
          'format': "h:mm a"
        },
        "data": data
      })) + "\n  </div>\n  <div>\n    <strong>Location: </strong>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.original : depth0) != null ? stack1.location : stack1, depth0)) + "\n  </div>\n  <div class=\"btn-container\">\n    <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs view-event-details-btn\" data-meetingid=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.original : depth0) != null ? stack1.id : stack1, depth0)) + "\"><span class=\"glyphicon glyphicon-chevron-right pull-right\"></span> View Details</div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["meeting.list.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view new-meeting-btn\"><i class=\"fa-icon fa-icon-plus pull-right\"></i>CREATE MEETING</div>\n";
    },
    "3": function _(depth0, helpers, partials, data, depths) {
      var helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing;
      return "        <div class=\"month-item\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" style=\"width: " + escapeExpression(lambda(depths[1] != null ? depths[1].width : depths[1], depth0)) + ";\">" + escapeExpression((helper = (helper = helpers['long'] || (depth0 != null ? depth0['long'] : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "long",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "5": function _(depth0, helpers, partials, data, depths) {
      var helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing;
      return "        <div class=\"month-item\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" style=\"width: " + escapeExpression(lambda(depths[1] != null ? depths[1].width : depths[1], depth0)) + ";\">" + escapeExpression((helper = (helper = helpers['short'] || (depth0 != null ? depth0['short'] : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "short",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data, depths) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"content-header content-padding-top content-padding content-margin clearfix content-underline padding\">\n  <div class=\"pull-right top-buttons\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canCreate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  </div>\n  <div class=\"rs-header-title\">\n    <span class=\"large-title-text\">Meetings</span>\n  </div>\n</div>\n<div class=\"content-margin clearfix content-padding\">\n  <div class=\"pull-right\">\n    <div class=\"\">\n      <span role=\"button\" tabindex=\"0\" class=\"previous-year-btn\"></span>\n      <span role=\"button\" tabindex=\"0\" class=\"xlarge-title-text year-text\">2014</span>\n      <span role=\"button\" tabindex=\"0\" class=\"next-year-btn\"></span>\n    </div>\n  </div>\n  <div class=\"pull-left\">\n    <div>\n      <span role=\"button\" tabindex=\"0\" class=\"previous-month-btn\"></span>\n      <span role=\"button\" tabindex=\"0\" class=\"xlarge-title-text month-text\">March</span>\n      <span role=\"button\" tabindex=\"0\" class=\"next-month-btn\"></span>\n    </div>\n  </div>\n</div>\n<div class=\"content-body content-padding clearfix text-center\">\n  <div class=\"calendar-width-container\">\n    <div class=\"month-row content-margin visible-md visible-lg\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.months : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(3, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n    <div class=\"month-row content-margin visible-xs visible-sm\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.months : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(5, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n    <div class=\"meeting-calendar-container\"></div>\n  </div>\n</div>\n";
    },
    "useData": true,
    "useDepths": true
  });
  this["RSTemplates"]["meeting.summary.list"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <div class=\"meeting-list-item\" data-meetingid=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n        <strong>" + escapeExpression((helpers.dateFormat || depth0 && depth0.dateFormat || helperMissing).call(depth0, depth0 != null ? depth0.startDate : depth0, {
        "name": "dateFormat",
        "hash": {
          'format': "LT"
        },
        "data": data
      })) + "</strong> " + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "\n      </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"meetings-scroller\">\n  <div class=\"meeting-list-row\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.MultipleMeetings : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["meeting.note"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "last";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "even";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "odd";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        buffer = "<div class=\"content-padding ";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " meeting-document-note ";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, data && data.odd, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n  <div class=\"row\">\n    <div class=\"col-sm-2\">\n      <strong>" + escapeExpression((helpers.dateFormat || depth0 && depth0.dateFormat || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.meeting : depth0) != null ? stack1.startDate : stack1, {
        "name": "dateFormat",
        "hash": {
          'format': "MM/DD/YYYY"
        },
        "data": data
      })) + "</strong>\n    </div>\n    <div class=\"col-sm-10 meeting-document-note-body\">";
      stack1 = (helper = (helper = helpers.notes || (depth0 != null ? depth0.notes : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "notes",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["meeting.notes"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div class=\"rs-navigation-previous\">\n        <span class=\"glyphicon glyphicon-chevron-left\"></span> Meeting\n      </div>\n      <div class=\"rs-navigation-divider\"></div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = this.invokePartial(partials['meeting.note'], '      ', 'meeting.note', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"content-header content-page-width content-underline clearfix\">\n    <div class=\"navigation-header\">\n      <div class=\"pull-right\">\n        <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view\"><i class=\"fa-icon fa-icon-external-link pull-right\"></i> VIEW SUBMISSION</div>\n      </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hasMeeting : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      <div class=\"rs-navigation-title\">\n        <div style=\"margin-top: 5px; margin-bottom: -5px;\">\n          IRB NUMBER: <strong>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.studyLabel : stack1, depth0)) + "</strong>\n        </div>\n        <div class=\"large-title-text\" style=\"line-height: normal;\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.title : stack1, depth0)) + " Notes</div>\n      </div>\n    </div>\n  </div>\n  <div class=\"content-body meeting-notes-body\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.notes : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["print.letter.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<div>\n  ";
      stack1 = (helper = (helper = helpers.content || (depth0 != null ? depth0.content : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "content",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["audit.report.edit.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "Create Report";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "Report: " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.report : depth0) != null ? stack1.name : stack1, depth0));
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "        <div class=\"clearfix\">\n          <i class=\"pull-right\">Created By: " + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.report : depth0) != null ? stack1.author : stack1) != null ? stack1.displayName : stack1, depth0)) + "</i>\n        </div>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "            <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs danger wide-view cancel-edit-report-btn\"><i class=\"fa-icon fa-icon-times-circle pull-right\"></i>Cancel</div>\n            <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view save-run-new-report-btn\"><i class=\"fa-icon fa-icon-caret-square-o-right pull-right\"></i>Save and Run</div>\n            <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view save-new-report-btn\"><i class=\"fa-icon fa-icon-floppy-o pull-right\"></i>Save</div>\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      return "            <div data-mode=\"view\">\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs danger wide-view cancel-edit-report-btn\"><i class=\"fa-icon fa-icon-times-circle pull-right\"></i>Cancel</div>\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view run-report-btn\"><i class=\"fa-icon fa-icon-play pull-right\"></i>Run</div>\n            </div>\n            <div data-mode=\"edit\">\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs danger wide-view cancel-edit-report-btn\"><i class=\"fa-icon fa-icon-times-circle pull-right\"></i>Cancel</div>\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view save-run-report-btn\"><i class=\"fa-icon fa-icon-caret-square-o-right pull-right\"></i>Save and Run</div>\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view save-report-btn\"><i class=\"fa-icon fa-icon-floppy-o pull-right\"></i>Save</div>\n            </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content-page-width\">\n\n  <div class=\"content-header content-page-width content-padding content-underline\">\n    <div class=\"clearfix\">\n      <div class=\"rs-navigation-previous\">\n        <span class=\"glyphicon glyphicon-chevron-left\"></span>Report List\n      </div>\n      <div class=\"rs-navigation-divider light\"></div>\n      <div class=\"rs-navigation-title\">\n        <span class=\"large-title-text\">";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.report : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"content-body\">\n    <div class=\"new-report-form content-padding content-padding-top content-padding-bottom\">\n      <div class=\"form-container\">\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.report : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        <div class=\"content-margin-small\">\n          <span class=\"md-title-text\">What would you like to name your report?</span>\n        </div>\n        <div class=\"row content-margin-medium\">\n          <div class=\"col-md-12\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Enter title of the report\" data-validate=\"name\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.report : depth0) != null ? stack1.name : stack1, depth0)) + "\"/>\n          </div>\n        </div>\n\n        <div class=\"\">\n          <span class=\"md-title-text\">What would you like to see?</span>\n        </div>\n\n        <div class=\"row content-margin-medium\" data-mode=\"edit\">\n          <div class=\"col-sm-12\">\n            <ul class=\"nav nav-tabs nav-sm\">\n              <li class=\"active\"><a href=\"#study-report-fields\" data-toggle=\"tab\">Study Information</a></li>\n              <li><a href=\"#audit-report-fields\" data-toggle=\"tab\">Audit Information</a></li>\n            </ul>\n            <div class=\"left-block-container tab-content\">\n              <div class=\"tab-pane active\" id=\"study-report-fields\"><div class=\"list-group\"></div></div>\n              <div class=\"tab-pane\" id=\"audit-report-fields\"><div class=\"list-group\"></div></div>\n              <div class=\"drop-overlay\"></div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row content-margin-medium\">\n          <div class=\"col-sm-12\">\n            <div>Report Columns</div>\n            <div class=\"right-block-container\" data-validate=\"columns\">\n              <div class=\"list-group\"></div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row content-margin-medium\">\n          <div class=\"col-md-12\">\n            <div class=\"\">Report Preview</div>\n            <div class=\"report-preview-container\"></div>\n          </div>\n        </div>\n\n        <br/>\n        <div class=\"row\">\n          <div class=\"col-md-12 text-right\">\n";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.report : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.program(9, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["audit.reporting.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div class=\"pull-right\">\n        <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs new-report-btn\"><i class=\"fa-icon fa-icon-plus pull-right\"></i>Create Report</div>\n      </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"content-page-width\">\n\n  <div class=\"content-header content-page-width content-padding content-padding-bottom\">\n    <div class=\"clearfix\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "      <div class=\"large-title-text\">Reporting</div>\n    </div>\n  </div>\n\n  <div class=\"content-body\">\n    <div class=\"content-bar-dark\">\n      <div class=\"rs-filter-group pull-right\" style=\"margin-bottom: 5px;\">\n        <i class=\"fa-icon fa-icon-search\"></i>\n        <input type=\"search\" class=\"filter-input\" placeholder=\"Search\" />\n        <i class=\"fa-icon fa-icon-times-circle filter-clear pull-right\"></i>\n      </div>\n    </div>\n    <div class=\"report-list-container use-highlight use-selected-carrot\"></div>\n  </div>\n\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["block.item"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda;
      return "<div class=\"list-group-item block\" data-field=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\" data-type=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.type : depth0) != null ? stack1.name : stack1, depth0)) + "\">\n  <span class=\"label pull-right\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.type : depth0) != null ? stack1.description : stack1, depth0)) + "</span>\n  <div class=\"item-text\" title=\"" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["report.actions"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <i role=\"button\" tabindex=\"0\" class=\"fa-icon fa-icon-trash-o delete-report-btn\" title=\"Delete\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<span class=\"report-actions\">\n  <i role=\"button\" tabindex=\"0\" class=\"fa-icon fa-icon-play run-report-btn\" title=\"Run Report\"></i>\n  <i role=\"button\" tabindex=\"0\" class=\"fa-icon fa-icon-pencil-square-o edit-report-btn\" title=\"Edit Report\"></i>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.modifyPermission : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</span>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["reviewboard.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return " checked";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.reviewBoardMembers : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                  <div class=\"data-row\">\n                    <div class=\"data-row-cell col-xs-10\">" + escapeExpression((helper = (helper = helpers.firstName || (depth0 != null ? depth0.firstName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "firstName",
        "hash": {},
        "data": data
      }) : helper)) + " <strong>" + escapeExpression((helper = (helper = helpers.lastName || (depth0 != null ? depth0.lastName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lastName",
        "hash": {},
        "data": data
      }) : helper)) + "</strong></div>\n                    <div class=\"data-row-cell col-xs-2 text-right\"><i role=\"button\" tabindex=\"0\" class=\"btn-delete-review-board-member fa-icon fa-icon-trash-o\" data-person-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\" style=\"cursor: pointer;\"></i></div>\n                  </div>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "                  <div class=\"data-row\">\n                    <div class=\"data-row-cell col-sm-12 text-center\"><i><br />No members selected for this review board.<br /><br /></i></div>\n                  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"row\">\n  <div class=\"form-update-review-board content-form content-padding content-margin\">\n    <div class=\"form-container\">\n      <div class=\"header clearfix\">\n        <span class=\"large-title-text pull-left\">Update Review Board</span>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <div class=\"row\">\n            <div class=\"col-sm-9\">\n              <div class=\"content-margin\"><i class=\"required\">*</i> Title:</div>\n              <input class=\"review-board-title form-control\" type=\"text\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.reviewBoard : depth0) != null ? stack1.name : stack1, depth0)) + "\" />\n              <div class=\"review-board-title-error input-error\">\n                <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n                <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n                <span class=\"error-message\"></span>\n              </div>\n            </div>\n            <div class=\"col-sm-3\">\n              <div class=\"content-margin\">Active:</div>\n              <div data-class-bool=\"checked\" class=\"checkbox-custom review-board-active-flg";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.reviewBoard : depth0) != null ? stack1.active : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\"></div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-12\">\n              <div class=\"content-margin\">Description:</div>\n              <textarea class=\"review-board-description form-control no-resize\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.reviewBoard : depth0) != null ? stack1.description : stack1, depth0)) + "</textarea>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-sm-6\">\n          <div class=\"row\">\n            <div class=\"col-sm-12 clearfix\">\n              <div class=\"content-margin\">Board Members:</div>\n              <div class=\"rs-simple-table member-list dark content-margin\">\n                <div class=\"data-rows-container\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.reviewBoardMembers : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(6, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                </div>\n              </div>\n              <div class=\"pull-right\">\n                <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-sm btn-create-review-board-member\"><i class=\"fa-icon fa-icon-plus pull-right\"></i> ADD IRB MEMBER</div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"clearfix\">\n        <div class=\"pull-left\">\n          <span class=\"required\"><i class=\"required\">*</i> - Required</span>\n        </div>\n        <div class=\"pull-right\">\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-delete-update-review-board\"><i class=\"fa-icon fa-icon-trash-o\"></i> DELETE</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-cancel-update-review-board\"><i class=\"fa-icon fa-icon-ban\"></i> CANCEL</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-save-update-review-board\"><i class=\"fa-icon fa-icon-save\"></i> SAVE</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["reviewboard.list.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"clearfix content-underline padding content-header content-padding content-page-width\">\n    <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-create-review-board pull-right\"><i class=\"fa-icon fa-icon-plus\"></i> CREATE REVIEW BOARD</div>\n    <div class=\"rs-header-title\">\n      <span class=\"large-title-text\">Manage Institutional Review Boards";
      stack1 = this.invokePartial(partials['help.anchor'], '', 'help.anchor', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</span>\n    </div>\n  </div>\n  <div class=\"content-body\">\n    <div class=\"form-new-review-board content-form\">\n      <div class=\"form-container\">\n        <div class=\"header clearfix\">\n          <span class=\"large-title-text pull-left\">Creating a New Review Board</span>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-10\">\n            <i class=\"required\">*</i> Title:\n            <input class=\"review-board-title form-control\" type=\"text\" />\n            <div class=\"review-board-title-error input-error\">\n              <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n          <div class=\"col-sm-2\">\n            Active:<br />\n            <div data-class-bool=\"checked\" class=\"checkbox-custom review-board-active-flg\"></div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            Description:\n            <textarea class=\"review-board-description form-control no-resize\"></textarea>\n          </div>\n        </div>\n        <div class=\"clearfix\">\n          <div class=\"pull-left bottom-buttons\"><span class=\"required\"><i class=\"required\">*</i> - Required</span></div>\n          <div class=\"pull-right\">\n            <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-cancel-create-review-board\"><i class=\"fa-icon fa-icon-ban\"></i> CANCEL</div>\n            <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-save-create-review-board\"><i class=\"fa-icon fa-icon-save\"></i> SAVE</div>\n          </div>\n          <div class=\"pull-right content-padding bottom-buttons\"><i>NOTE: You will be able to add members once the board is created.</i></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"review-board-list-container\">\n      <div class=\"content-bar-dark\">\n        <div class=\"rs-filter-group pull-right\" style=\"margin-bottom: 5px;\">\n          <i class=\"fa-icon fa-icon-search\"></i>\n          <input type=\"text\" class=\"filter-input\" placeholder=\"Filter\" />\n          <i class=\"fa-icon fa-icon-times-circle filter-clear pull-right\"></i>\n        </div>\n      </div>\n      <div class=\"review-board-grid-container use-highlight use-selected-carrot\"></div>\n    </div>\n  </div>\n  <div class=\"clearfix\"></div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["settings.irb.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              ";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n              <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                  <label>" + escapeExpression((helper = (helper = helpers.param || (depth0 != null ? depth0.param : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "param",
        "hash": {},
        "data": data
      }) : helper)) + "</label>\n                  <select class=\"form-control\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.options : depth0, depth0 != null ? depth0.value : depth0, "value", {
        "name": "foreach",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                  </select>\n                </div>\n              </div>\n              ";
      stack1 = helpers['if'].call(depth0, data && data.odd, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n              ";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "<div class=\"row\">";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                    <option ";
      stack1 = helpers['if'].call(depth0, data && data.selected, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "selected=\"selected\"";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "</div>";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"clearfix content-margin content-padding content-underline padding content-header content-page-width\">\n    <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary save-settings-btn pull-right\"><i class=\"fa-icon fa-icon-cog\"></i> SAVE SETTINGS</div>\n    <div class=\"rs-header-title\">\n      <span class=\"large-title-text\">Manage Application Settings";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "help.anchor", {
        "name": "inject",
        "hash": {
          'help': depth0 != null ? depth0.mainHelp : depth0
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</span>\n    </div>\n  </div>\n  <div class=\"content-body content-padding form-settings content-form\">\n    <div class=\"row\">\n      <div class=\"col-md-12\"><h2>General</h2></div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.officeName : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control office-name\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.officeName : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.officeName : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "office-name"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.notificationFrom : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control notification-from\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.notificationFrom : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.notificationFrom : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "notification-from"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-12\"><h2>Study</h2></div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.sequenceNumberReset : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          " + escapeExpression((helpers.checkbox || depth0 && depth0.checkbox || helperMissing).call(depth0, {
        "name": "checkbox",
        "hash": {
          'checked': (stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.sequenceNumberReset : stack1) != null ? stack1.value : stack1,
          'id': (stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.sequenceNumberReset : stack1) != null ? stack1.id : stack1
        },
        "data": data
      })) + "\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.studyDefaultExpirationInterval : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control study-default-expiration-interval\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.studyDefaultExpirationInterval : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.studyDefaultExpirationInterval : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "study-default-expiration-interval"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.studyLabelPrefix : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control study-label-prefix\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.studyLabelPrefix : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.studyLabelPrefix : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "study-label-prefix"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-12\"><h2>Workflow</h2></div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.hasOrgApprovers : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <div class=\"has-org-approvers-cb\">" + escapeExpression((helpers.checkbox || depth0 && depth0.checkbox || helperMissing).call(depth0, {
        "name": "checkbox",
        "hash": {
          'checked': (stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.hasOrgApprovers : stack1) != null ? stack1.value : stack1,
          'id': (stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.hasOrgApprovers : stack1) != null ? stack1.id : stack1
        },
        "data": data
      })) + "</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row submission-org-approvers-group\">\n      <div class=\"col-md-12\">\n        <div class=\"form-group\">\n          <label>When do these submissions require organizational approval?</label>\n          <div style=\"padding: 5px 20px; border-left: 1px solid #ccc;\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.orgAppIterSettings : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"form-group\">\n          <label>Who is required to certify these submissions?</label>\n          <div style=\"padding: 5px 20px; border-left: 1px solid #ccc;\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.certifySettings : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"form-group\">\n          <label>Who is required to recertify these submissions?</label>\n          <div style=\"padding: 5px 20px; border-left: 1px solid #ccc;\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.recertifySettings : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.levelsOfOrgApprovers : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control levels-of-org-approvers\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.levelsOfOrgApprovers : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.levelsOfOrgApprovers : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "levels-of-org-approvers"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"row\">\n      <div class=\"col-md-12\"><h2>Notifications &amp; Messages</h2></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.taskReminderInterval : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control task-reminder-interval\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.taskReminderInterval : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.taskReminderInterval : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "task-reminder-interval"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.taskReminderMessageInterval : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control task-reminder-message-interval\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.taskReminderMessageInterval : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.taskReminderMessageInterval : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "task-reminder-message-interval"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.renewalReminderInterval : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control renewal-reminder-interval\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.renewalReminderInterval : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.renewalReminderInterval : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "renewal-reminder-interval"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.renewalReminderMessageInterval : stack1) != null ? stack1.description : stack1, depth0)) + "</label>\n          <input type=\"text\" class=\"form-control renewal-reminder-message-interval\" data-id=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.renewalReminderMessageInterval : stack1) != null ? stack1.id : stack1, depth0)) + "\" value=\"" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.settings : depth0) != null ? stack1.renewalReminderMessageInterval : stack1) != null ? stack1.value : stack1, depth0)) + "\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "renewal-reminder-message-interval"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["assignment.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                <option value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "value",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "Selected";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                  <option value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "value",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "selected";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "                <option value=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"clearfix content-padding content-underline padding content-header content-page-width\">\n    <div class=\"navigation-header\">\n      <div class=\"rs-navigation-previous\">\n        <span class=\"glyphicon glyphicon-chevron-left\"></span>\n        SUBMISSION DETAILS\n      </div>\n      <div class=\"rs-navigation-divider\"></div>\n      <div class=\"rs-navigation-title\">\n        <span class=\"large-title-text\">Assign IRB</span>\n      </div>\n    </div>\n  </div>\n  <div class=\"content-body\">\n    <div class=\"content-form\">\n      <div class=\"form-container\">\n\n        <!-- Review Type Selection -->\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <label><i class=\"required\">*</i> Choose a Review Type</label>\n            <select class=\"form-control irb-review-type\" data-prop=\"type\">\n              <option value=\"\">Select Review Type</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.reviewTypes : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "            </select>\n          </div>\n        </div>\n\n        <!-- Full Expedited -->\n        <div class=\"row full-expedited-type\">\n          <div class=\"col-sm-12\">\n            <label>Is this a Full Expedited Review?</label>\n            <div class=\"is-full-expedited-cb\">" + escapeExpression((helpers.checkbox || depth0 && depth0.checkbox || helperMissing).call(depth0, depth0 != null ? depth0.isFullExpedited : depth0, {
        "name": "checkbox",
        "hash": {},
        "data": data
      })) + "</div>\n          </div>\n        </div>\n\n        <!-- Board or Analyst Type Selection -->\n        <div class=\"row exempt-type board-analyst-container\">\n          <div class=\"col-sm-12\">\n            <label class=\"required-text\">Are you choosing a Board Member or an Analyst?</label>\n            <select class=\"form-control exempt-reviewer-type reviewer-type\">\n                <option value=\"\">Select One</option>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.reviewerTypes : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "            </select>\n          </div>\n        </div>\n\n        <!-- Board Selection -->\n        <div class=\"row board-selection\">\n          <div class=\"col-sm-12\">\n            <label class=\"required-text\">Pick Your Board</label>\n            <select class=\"form-control irb-board\">\n              <option value=\"NaN\">Select Review Board</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.boards : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "            </select>\n          </div>\n        </div>\n\n        <!-- Full Expedited Reviewer -->\n        <div class=\"row full-expedited-reviewer-selection\">\n          <div class=\"col-sm-12\">\n            <label class=\"required-text\">Assign a Reviewer</label>\n            <select class=\"form-control full-expedited-reviewer\" disabled></select>\n          </div>\n        </div>\n\n        <!-- FullBoard Board Members -->\n        <div class=\"row fullboard-type\">\n          <div class=\"col-sm-6\">\n            <label>Assign Primary Board Member</label>\n            <select class=\"form-control primary-irb-member\" disabled></select>\n          </div>\n          <div class=\"col-sm-6\">\n            <label>Assign Secondary Board Member</label>\n            <select class=\"form-control secondary-irb-member\"></select>\n          </div>\n        </div>\n\n        <!-- Exempt or Expedited Primary Reviewer -->\n        <div class=\"row expedited-type exempt-type\">\n          <div class=\"col-sm-12\">\n            <label>Assign a Primary Reviewer</label>\n            <select class=\"form-control primary-expedited-reviewer\"></select>\n          </div>\n        </div>\n\n        <!-- Exempt or Expedited Board Members -->\n        <div class=\"board-member-selection\">\n          <div class=\"row content-padding-top\">\n            <div class=\"col-sm-12\">\n              <label>Click on the person(s) that you would like to review the submission</label>\n              <div class=\"assignment-member-list-grid-container use-side-highlight\"></div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <br /><div role=\"button\" tabindex=\"0\" class=\"btn btn-primary assignment-save-btn pull-right\">ASSIGN IRB</div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["document.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.statusColor : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "            <span class=\"label label-" + escapeExpression((helper = (helper = helpers.statusColor || (depth0 != null ? depth0.statusColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "statusColor",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "            <span class=\"label label-default\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "          <span class=\"muted\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "        <div class=\"tab\" data-tab=\"decisions\">Decisions</div>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hasTaskSummaries : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.meetings : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "11": function _(depth0, helpers, partials, data) {
      return "          <div class=\"tab\" data-tab=\"task-summaries\">Approvals</div>\n";
    },
    "13": function _(depth0, helpers, partials, data) {
      return "          <div class=\"tab\" data-tab=\"meetings\">Meetings</div>\n";
    },
    "15": function _(depth0, helpers, partials, data) {
      return "        <div class=\"tab\" data-tab=\"letters\">Letters</div>\n";
    },
    "17": function _(depth0, helpers, partials, data) {
      return "        <div class=\"tab\" data-tab=\"history\">History</div>\n";
    },
    "19": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.withdrawal : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(20, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "20": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.decisionStatus : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(21, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "21": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                <div class=\"col-md-2 col-sm-4 col-sm-4 content-margin\">\n                  <div class=\"study-label\">Decision</div>\n                  <div class=\"study-field-value\">\n                    " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.decisionStatus : stack1, depth0)) + "\n                  </div>\n                </div>\n";
    },
    "23": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "            <div class=\"col-sm-4 content-margin\">\n              <div class=\"study-label\">" + escapeExpression((helper = (helper = helpers.currentUserDisplayName || (depth0 != null ? depth0.currentUserDisplayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "currentUserDisplayName",
          "hash": {},
          "data": data
        }) : helper)) + "&#39;s role</div>\n              <div class=\"study-field-value\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.currentUserAssignments : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(24, data),
        "inverse": this.program(30, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "              </div>\n            </div>\n\n";
    },
    "24": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.currentUserAssignments : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.program(28, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "25": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers.unless.call(depth0, data && data.first, {
        "name": "unless",
        "hash": {},
        "fn": this.program(26, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                    <span style=\"white-space: nowrap\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.assignmentType : depth0) != null ? stack1.displayName : stack1, depth0)) + "</span>\n";
    },
    "26": function _(depth0, helpers, partials, data) {
      return "                    ,&nbsp;\n";
    },
    "28": function _(depth0, helpers, partials, data) {
      return "                    None\n";
    },
    "30": function _(depth0, helpers, partials, data) {
      return "                  None\n";
    },
    "32": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.IRB_REVIEW_TYPE : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(33, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.IRB_ANALYST : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(35, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "33": function _(depth0, helpers, partials, data) {
      var helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <div class=\"col-md-2 col-sm-4 content-margin\">\n                <div class=\"study-label\">Review Type</div>\n                <div class=\"study-field-value\">" + escapeExpression((helpers.ProperCase || depth0 && depth0.ProperCase || helperMissing).call(depth0, depth0 != null ? depth0.IRB_REVIEW_TYPE : depth0, {
        "name": "ProperCase",
        "hash": {},
        "data": data
      })) + "</div>\n              </div>\n";
    },
    "35": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "              <div class=\"col-md-2 col-sm-4 content-margin\">\n                <div class=\"study-label\">Current Analyst</div>\n                <div class=\"study-field-value analyst-display\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.IRB_ANALYST : depth0) != null ? stack1.displayName : stack1, depth0)) + "</div>\n              </div>\n";
    },
    "37": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "              <div class=\"content-margin pull-left-sm\" style=\"margin-right: 5px;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.select : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(38, data),
        "inverse": this.program(40, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "              </div>\n";
    },
    "38": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                  <div>\n                    <input type=\"hidden\" data-action=\"" + escapeExpression((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "action",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n                  </div>\n";
    },
    "40": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                  <div role=\"button\" tabindex=\"0\" class=\"document-action-btn btn btn-rs wide-view " + escapeExpression((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "color",
          "hash": {},
          "data": data
        }) : helper)) + "\" data-action=\"" + escapeExpression((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "action",
          "hash": {},
          "data": data
        }) : helper)) + "\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(41, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                    " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n                  </div>\n";
    },
    "41": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                      <i class=\"fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " pull-right\"></i>\n";
    },
    "43": function _(depth0, helpers, partials, data) {
      return "              <div class=\"content-margin\">\n                <i>No Available Tasks</i>\n              </div>\n";
    },
    "45": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "                <div class=\"content-margin content-padding-right pull-left-sm\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.select : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(46, data),
        "inverse": this.program(48, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                </div>\n";
    },
    "46": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                    <input type=\"hidden\" data-action=\"" + escapeExpression((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "action",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "48": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                    <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view document-action-btn ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.complete : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(49, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-action=\"" + escapeExpression((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "action",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(51, data),
        "inverse": this.program(53, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                      " + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "\n                    </div>\n";
    },
    "49": function _(depth0, helpers, partials, data) {
      return "success";
    },
    "51": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                        <i class=\"fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " pull-right\"></i>\n";
    },
    "53": function _(depth0, helpers, partials, data) {
      return "                        <i class=\"fa-icon fa-icon-cog pull-right\"></i>\n";
    },
    "55": function _(depth0, helpers, partials, data) {
      return "                <div class=\"content-margin\">\n                  <i>You have completed all required tasks.</i>\n                </div>\n";
    },
    "57": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                <div class=\"content-margin content-padding-right pull-left-sm\">\n                  <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view document-task-action-btn\" style=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.rightAlign : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(58, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " min-width: 215px;\" data-value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n                    <i class=\"fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.rightAlign : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(60, data),
        "inverse": this.program(62, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" style=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.rightAlign : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(64, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></i>\n                    " + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "\n                  </div>\n                </div>\n";
    },
    "58": function _(depth0, helpers, partials, data) {
      return "text-align: right;";
    },
    "60": function _(depth0, helpers, partials, data) {
      return "pull-left";
    },
    "62": function _(depth0, helpers, partials, data) {
      return "pull-right";
    },
    "64": function _(depth0, helpers, partials, data) {
      return "padding-left:0px;";
    },
    "66": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "                <div class=\"content-margin\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.routingMessage : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(67, data),
        "inverse": this.program(69, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                </div>\n";
    },
    "67": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                    <i>" + escapeExpression((helper = (helper = helpers.routingMessage || (depth0 != null ? depth0.routingMessage : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "routingMessage",
        "hash": {},
        "data": data
      }) : helper)) + "</i>\n";
    },
    "69": function _(depth0, helpers, partials, data) {
      return "                    <i>You cannot perform any actions at this time.</i>\n";
    },
    "71": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "      <div class=\"content-margin-large\">\n        <div class=\"clearfix content-margin-large\"></div>\n        <div class=\"content-padding-lg content-margin\">\n          <div class=\"study-label content-indent-marker\">Investigator(s) that must certify this Submission</div>\n        </div>\n        <div class=\"e3-table rs-theme\">\n          <div class=\"e3-table-header\">\n            <div class=\"e3-table-header-cell first\" style=\"width: 25%;\">Investigator</div>\n            <div class=\"e3-table-header-cell\" style=\"width: 50%;\">Role</div>\n            <div class=\"e3-table-header-cell last\" style=\"width: 25%;\">Certified</div>\n          </div>\n          <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.taskSummaries : depth0) != null ? stack1.CERTIFY : stack1, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(72, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "          </div>\n        </div>\n      </div>\n";
    },
    "72": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <div class=\"e3-table-row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.taskEndedBy : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(73, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" style=\"";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(75, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n                <div class=\"e3-table-row-content\">\n                  <div class=\"e3-table-row-cell first approval-cell-fix\" data-title=\"Investigator\" style=\"width: 25%;\">" + escapeExpression((helper = (helper = helpers.peopleDisplayName || (depth0 != null ? depth0.peopleDisplayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "peopleDisplayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                  <div class=\"e3-table-row-cell approval-cell-fix\" data-title=\"Role\" style=\"width: 50%;\">" + escapeExpression((helper = (helper = helpers.assignment || (depth0 != null ? depth0.assignment : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "assignment",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                  <div class=\"e3-table-row-cell last\" data-title=\"Certified\" style=\"width: 25%;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.taskEndDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(77, data),
        "inverse": this.program(79, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                  </div>\n                </div>\n              </div>\n";
    },
    "73": function _(depth0, helpers, partials, data) {
      return "fix-cells";
    },
    "75": function _(depth0, helpers, partials, data) {
      return "background-color: white;";
    },
    "77": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                      <div>" + escapeExpression((helper = (helper = helpers.taskEndedBy || (depth0 != null ? depth0.taskEndedBy : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "taskEndedBy",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                      <h6 class=\"no-margin\">" + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, depth0 != null ? depth0.taskEndDate : depth0, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY LT"
        },
        "data": data
      })) + "</h6>\n";
    },
    "79": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.response : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(80, data),
        "inverse": this.program(82, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "80": function _(depth0, helpers, partials, data) {
      return "                        <div>Completed</div>\n";
    },
    "82": function _(depth0, helpers, partials, data) {
      return "                      <span class=\"muted\">Pending Certification</span>\n";
    },
    "84": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "      <div class=\"content-margin-large\">\n        <div class=\"clearfix\"></div>\n        <div class=\"content-padding-lg content-margin\">\n          <div class=\"study-label content-indent-marker\">Department(s) that must authorize this Submission</div>\n        </div>\n        <div class=\"e3-table rs-theme\">\n          <div class=\"e3-table-header\">\n            <div class=\"e3-table-header-cell first\" style=\"width: 25%;\">Department</div>\n            <div class=\"e3-table-header-cell\" style=\"width: 50%;\">Authorizing Person(s)</div>\n            <div class=\"e3-table-header-cell last\" style=\"width: 25%;\">Authorized</div>\n          </div>\n          <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.taskSummaries : depth0) != null ? stack1.ORG_APPROVED : stack1, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(85, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "          </div>\n        </div>\n      </div>\n";
    },
    "85": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <div class=\"e3-table-row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.taskEndedBy : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(73, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" style=\"";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(75, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n                <div class=\"e3-table-row-content\">\n                  <div class=\"e3-table-row-cell first approval-cell-fix\" data-title=\"Department\" style=\"width: 25%;\">" + escapeExpression((helper = (helper = helpers.organizationName || (depth0 != null ? depth0.organizationName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "organizationName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                  <div class=\"e3-table-row-cell approval-cell-fix\" data-title=\"Authorizing Person(s)\" style=\"width: 50%;\">" + escapeExpression((helper = (helper = helpers.peopleDisplayName || (depth0 != null ? depth0.peopleDisplayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "peopleDisplayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                  <div class=\"e3-table-row-cell last\" data-title=\"Authorized\" style=\"width: 25%;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.taskEndDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(86, data),
        "inverse": this.program(82, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                  </div>\n                </div>\n              </div>\n";
    },
    "86": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                      <div class=\"pull-left\">\n                        <div>" + escapeExpression((helper = (helper = helpers.taskEndedBy || (depth0 != null ? depth0.taskEndedBy : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "taskEndedBy",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                        <h6 class=\"no-margin\">" + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, depth0 != null ? depth0.taskEndDate : depth0, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY LT"
        },
        "data": data
      })) + "</h6>\n                      </div>\n";
    },
    "88": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "            <div class=\"e3-table-row document-meeting\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "id",
          "hash": {},
          "data": data
        }) : helper)) + "\" style=\"";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(75, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\">\n              <div class=\"e3-table-row-content\">\n                <div class=\"e3-table-row-cell first\" data-title=\"Date\" style=\"width: 33%;\">" + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, depth0 != null ? depth0.startDate : depth0, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY LT"
        },
        "data": data
      })) + "</div>\n                <div class=\"e3-table-row-cell last\" data-title=\"Location\" style=\"width: 67%;\">" + escapeExpression((helper = (helper = helpers.location || (depth0 != null ? depth0.location : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "location",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n              </div>\n            </div>\n";
    },
    "90": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, (stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.finalized : stack1, {
        "name": "unless",
        "hash": {},
        "fn": this.program(91, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "91": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "        <div class=\"content-margin content-padding-lg\">\n          <div class=\"content-margin\">\n            <div class=\"study-label content-indent-marker\">Digest</div>\n          </div>\n        </div>\n        <div class=\"content-margin-large\">\n          <div class=\"e3-table rs-theme\">\n            <div class=\"e3-table-header\">\n              <div class=\"e3-table-header-cell first\" style=\"width: 8%;\">&nbsp;</div>\n              <div class=\"e3-table-header-cell\" style=\"width: 25%;\">Name</div>\n              <div class=\"e3-table-header-cell\" style=\"width: 25%;\">Role</div>\n              <div class=\"e3-table-header-cell last\" style=\"width: 15%;\">Decision</div>\n              <div class=\"e3-table-header-cell last\" style=\"width: 27%;\">&nbsp;</div>\n            </div>\n            <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.childDecisions : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(92, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "            </div>\n          </div>\n        </div>\n";
    },
    "92": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda,
        buffer = "                <div class=\"e3-table-row child-decision ";
      stack1 = helpers['if'].call(depth0, depths[1] != null ? depths[1].promoteDecisions : depths[1], {
        "name": "if",
        "hash": {},
        "fn": this.program(93, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n                  <div class=\"e3-table-row-content\">\n                    <div class=\"e3-table-row-cell text-center first\" style=\"width: 8%;\">\n";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.decisionType : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(95, data, depths),
        "inverse": this.program(97, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                    </div>\n                    <div class=\"e3-table-row-cell\" style=\"width: 25%;\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.responsiblePerson : depth0) != null ? stack1.displayName : stack1, depth0)) + "</div>\n                    <div class=\"e3-table-row-cell\" style=\"width: 25%;\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.responsiblePersonAssignment : depth0) != null ? stack1.displayName : stack1, depth0)) + "</div>\n                    <div class=\"e3-table-row-cell last\" style=\"width: 15%;\">\n";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.decisionType : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(99, data, depths),
        "inverse": this.program(101, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                    </div>\n                    <div class=\"e3-table-row-cell last\" style=\"width: 27%\">\n                      <div role=\"button\" tabindex=\"0\" class=\"btn btn-default promote-decision-btn\"><i class=\"fa-icon fa-icon-check pull-right\"></i>Select Decision</div>\n                    </div>\n                  </div>\n                </div>\n";
    },
    "93": function _(depth0, helpers, partials, data) {
      return "selectable";
    },
    "95": function _(depth0, helpers, partials, data) {
      return "                        <span class=\"muted glyphicon glyphicon-minus\"></span>\n";
    },
    "97": function _(depth0, helpers, partials, data) {
      return "                        <span class=\"glyphicon glyphicon-ok\"></span>\n";
    },
    "99": function _(depth0, helpers, partials, data) {
      return "                        <span class=\"muted\">Undecided</span>\n";
    },
    "101": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                        " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decisionType : depth0) != null ? stack1.description : stack1, depth0)) + "\n";
    },
    "103": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "      <div class=\"content-margin content-padding-lg\">\n        <div class=\"study-label content-indent-marker\">History</div>\n      </div>\n      <div class=\"document-decision-list e3-table rs-theme\">\n          <div class=\"e3-table-header\">\n            <div class=\"e3-table-header-cell first\" style=\"width: 33%;\">Decision Date</div>\n            <div class=\"e3-table-header-cell last\" style=\"width: 67%;\">Decision Outcome</div>\n          </div>\n          <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.decisions : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(104, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "          </div>\n      </div>\n";
    },
    "104": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda,
        buffer = "              <div class=\"e3-table-row document-decision\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "id",
          "hash": {},
          "data": data
        }) : helper)) + "\" style=\"";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(75, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\">\n                <div class=\"e3-table-row-content\">\n                  <div class=\"e3-table-row-cell first\" data-title=\"Decision Date\" style=\"width: 33%;\">" + escapeExpression((helpers.dateFormat || depth0 && depth0.dateFormat || helperMissing).call(depth0, depth0 != null ? depth0.finalizedDate : depth0, {
        "name": "dateFormat",
        "hash": {
          'format': "MM/DD/YYYY LT"
        },
        "data": data
      })) + "</div>\n                  <div class=\"e3-table-row-cell last\" data-title=\"Decision Outcome\" style=\"width: 67%;\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.decisionType : depth0) != null ? stack1.description : stack1, depth0)) + "</div>\n                </div>\n              </div>\n";
    },
    "106": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "          <div class=\"e3-table-row document-sent-letter\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "id",
          "hash": {},
          "data": data
        }) : helper)) + "\" style=\"";
      stack1 = helpers['if'].call(depth0, data && data.even, {
        "name": "if",
        "hash": {},
        "fn": this.program(107, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n            <div class=\"e3-table-row-content\">\n              <div class=\"e3-table-row-cell first\" data-title=\"Sent Date\" style=\"width: 25%;\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dateSent : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(109, data),
        "inverse": this.program(111, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n              <div class=\"e3-table-row-cell\" data-title=\"Subject\" style=\"width: 33%;\">" + escapeExpression((helper = (helper = helpers.subject || (depth0 != null ? depth0.subject : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "subject",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n              <div class=\"e3-table-row-cell last\" data-title=\"Recipients\" style=\"width: 42%\">" + escapeExpression((helper = (helper = helpers.recipients || (depth0 != null ? depth0.recipients : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "recipients",
        "hash": {},
        "data": data
      }) : helper)) + " &nbsp; " + escapeExpression((helper = (helper = helpers.cc || (depth0 != null ? depth0.cc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "cc",
        "hash": {},
        "data": data
      }) : helper)) + " &nbsp; " + escapeExpression((helper = (helper = helpers.bcc || (depth0 != null ? depth0.bcc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "bcc",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n            </div>\n          </div>\n";
    },
    "107": function _(depth0, helpers, partials, data) {
      return "background-color: #white;";
    },
    "109": function _(depth0, helpers, partials, data) {
      var helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helpers.dateFormat || depth0 && depth0.dateFormat || helperMissing).call(depth0, depth0 != null ? depth0.dateSent : depth0, {
        "name": "dateFormat",
        "hash": {
          'format': "MM/DD/YYYY LT"
        },
        "data": data
      }));
    },
    "111": function _(depth0, helpers, partials, data) {
      return " <i>Not Sent</i> ";
    },
    "113": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "      <div class=\"content-margin-large\">\n        <div class=\"clearfix content-margin-large\"></div>\n        <div class=\"content-padding-lg content-margin\">\n          <div class=\"study-label content-indent-marker\">Investigator(s) that certified this Submission</div>\n        </div>\n        <div class=\"e3-table rs-theme\">\n          <div class=\"e3-table-header\">\n            <div class=\"e3-table-header-cell first\" style=\"width: 25%;\">Investigator</div>\n            <div class=\"e3-table-header-cell\" style=\"width: 50%;\">Role</div>\n            <div class=\"e3-table-header-cell last\" style=\"width: 25%;\">Certified</div>\n          </div>\n          <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.taskHistory : depth0) != null ? stack1.CERTIFY : stack1, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(72, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "          </div>\n        </div>\n      </div>\n";
    },
    "115": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "      <div class=\"content-margin-large\">\n        <div class=\"clearfix\"></div>\n        <div class=\"content-padding-lg content-margin\">\n          <div class=\"study-label content-indent-marker\">Department(s) that authorized this Submission</div>\n        </div>\n        <div class=\"e3-table rs-theme\">\n          <div class=\"e3-table-header\">\n            <div class=\"e3-table-header-cell first\" style=\"width: 25%;\">Department</div>\n            <div class=\"e3-table-header-cell\" style=\"width: 50%;\">Authorizing Person(s)</div>\n            <div class=\"e3-table-header-cell last\" style=\"width: 25%;\">Authorized</div>\n          </div>\n          <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.taskHistory : depth0) != null ? stack1.ORG_APPROVED : stack1, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(85, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "          </div>\n        </div>\n      </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data, depths) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"\">\n\n  <div class=\"document-detail-header content-margin\">\n    <div class=\"content-padding-lg content-padding-top\">\n      <div>\n        <h2 style=\"display: inline;\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.templateType : stack1, depth0)) + " Submission</h2>\n      </div>\n      <div>\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.finalized : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data, depths),
        "inverse": this.program(6, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      </div>\n      <div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"content-padding-lg\">\n    <div class=\"rs-tabs\">\n      <div class=\"tab default-tab\" data-tab=\"details\">Dashboard</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.showDecisionsTab : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers.unless.call(depth0, (stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.finalized : stack1, {
        "name": "unless",
        "hash": {},
        "fn": this.program(10, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.letters : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hasHistory : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(17, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n  </div>\n\n  <div class=\"tab-content header-four-bg-color content-padding-lg padding-lg light-border-bottom light-border-top\" data-tab=\"details\">\n    <div class=\"document-info\">\n      <div class=\"\">\n        <div class=\"row\">\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.document : depth0) != null ? stack1.finalized : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(19, data, depths),
        "inverse": this.program(23, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['with'].call(depth0, depth0 != null ? depth0.assignments : depth0, {
        "name": "with",
        "hash": {},
        "fn": this.program(32, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n\n        </div>\n      </div>\n    </div>\n\n\n\n\n    <div class=\"content-padding-top\">\n      <div class=\"row\">\n\n        <div class=\"col-sm-4\">\n          <div class=\"activities-container clearfix\">\n            <div class=\"study-label content-margin-small\">Tasks</div>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.actions : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(37, data, depths),
        "inverse": this.program(43, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n        </div>\n\n        <div class=\"col-sm-4\">\n          <div class=\"required-activites-container\">\n            <div class=\"study-label content-margin-small\">Required Tasks</div>\n            <div class=\"clearfix\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.taskOperations : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(45, data, depths),
        "inverse": this.program(55, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "            </div>\n          </div>\n        </div>\n\n        <div class=\"col-sm-4\">\n          <div class=\"workflow-container\">\n            <div class=\"content-padding-right\">\n                <div class=\"study-label content-margin-small\">Submission Routing</div>\n            </div>\n            <div class=\"clearfix\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.taskAnswers : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(57, data, depths),
        "inverse": this.program(66, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n\n  <div class=\"tab-content e3-table-tight light-border-top\" data-tab=\"task-summaries\">\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.taskSummaries : depth0) != null ? stack1.CERTIFY : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(71, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.taskSummaries : depth0) != null ? stack1.ORG_APPROVED : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(84, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  </div>\n\n  <div class=\"tab-content e3-table-tight\" data-tab=\"meetings\">\n    <div class=\"document-meeting-list e3-table rs-theme\">\n        <div class=\"e3-table-header\">\n          <div class=\"e3-table-header-cell first\" style=\"width: 33%;\">Date</div>\n          <div class=\"e3-table-header-cell last\" style=\"width: 67%;\">Location</div>\n        </div>\n        <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.meetings : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(88, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "        </div>\n    </div>\n  </div>\n\n  <div class=\"tab-content e3-table-tight light-border-top\" data-tab=\"decisions\">\n    <div class=\"clearfix content-margin-large\"></div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.childDecisions : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(90, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.decisions : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(103, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  </div>\n\n  <div class=\"tab-content e3-table-tight\" data-tab=\"letters\">\n    <div class=\"document-letter-list e3-table rs-theme\">\n      <div class=\"e3-table-header\">\n        <div class=\"e3-table-header-cell first\" style=\"width: 25%;\">Sent Date</div>\n        <div class=\"e3-table-header-cell\" style=\"width: 33%;\">Subject</div>\n        <div class=\"e3-table-header-cell last\" style=\"width: 42%;\">Recipients</div>\n      </div>\n      <div class=\"e3-table-row-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.letters : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(106, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      </div>\n    </div>\n  </div>\n\n  <div class=\"tab-content e3-table-tight light-border-top\" data-tab=\"history\">\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.taskHistory : depth0) != null ? stack1.CERTIFY : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(113, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.taskHistory : depth0) != null ? stack1.ORG_APPROVED : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(115, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n\n</div>\n";
    },
    "useData": true,
    "useDepths": true
  });
  this["RSTemplates"]["sidebar.section.document"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "active";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return " - " + escapeExpression((helper = (helper = helpers.resultDate || (depth0 != null ? depth0.resultDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "resultDate",
        "hash": {},
        "data": data
      }) : helper));
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"sidebar-section-item ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-id=" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + ">\n  <div class=\"sidebar-section-item-content\">\n    <div>\n      <span class=\"sidebar-section-item-text\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n    </div>\n    <div>\n      <h6 class=\"muted no-margin\" style=\"text-transform: uppercase;\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper));
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.resultDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</h6>\n    </div>\n  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["study.contact.details"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda;
      return "<div class=\"study-label\">Principal Investigator</div>\n<div class=\"study-field-value\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n<div class=\"study-field-value\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.primaryAddress : depth0) != null ? stack1.fullAddress : stack1, depth0)) + "</div>\n<div class=\"study-field-value\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.primaryPhone : depth0) != null ? stack1.fullNumber : stack1, depth0)) + "</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["study.detail.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                <div class=\"label label-" + escapeExpression((helper = (helper = helpers.statusColor || (depth0 != null ? depth0.statusColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "statusColor",
        "hash": {},
        "data": data
      }) : helper)) + " pull-left\" style=\"margin-top: -8px\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                <div class=\"muted pull-left\" style=\"margin-top: -8px;\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "rs-hide";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = this.invokePartial(partials['study.contact.details'], '                  ', 'study.contact.details', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                  <div class=\"col-sm-3 content-margin\">\n                    <div class=\"study-label\">Organization";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.multiOrgs : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n                    <div class=\"study-field-value\">" + escapeExpression((helper = (helper = helpers.organizations || (depth0 != null ? depth0.organizations : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "organizations",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                  </div>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      return "s";
    },
    "12": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                  <div class=\"col-sm-3 content-margin\">\n                    <div class=\"study-label\">Name of Sponsor</div>\n                    <div class=\"study-field-value\">" + escapeExpression((helper = (helper = helpers.sponsor || (depth0 != null ? depth0.sponsor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "sponsor",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                  </div>\n";
    },
    "14": function _(depth0, helpers, partials, data) {
      var helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                      " + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, depth0 != null ? depth0.approvalDate : depth0, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY"
        },
        "data": data
      })) + "\n";
    },
    "16": function _(depth0, helpers, partials, data) {
      return "                      <span>-</span>\n";
    },
    "18": function _(depth0, helpers, partials, data) {
      var helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                      " + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, depth0 != null ? depth0.expirationDate : depth0, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY"
        },
        "data": data
      })) + "\n";
    },
    "20": function _(depth0, helpers, partials, data) {
      return "                    -\n";
    },
    "22": function _(depth0, helpers, partials, data) {
      var helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                      " + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, depth0 != null ? depth0.finalizedDate : depth0, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY"
        },
        "data": data
      })) + "\n";
    },
    "24": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                  <div class=\"col-sm-3 content-margin\">\n                    <div class=\"study-label\">Review Board</div>\n                    <div class=\"study-field-value\">" + escapeExpression((helper = (helper = helpers.reviewBoard || (depth0 != null ? depth0.reviewBoard : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "reviewBoard",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                  </div>\n";
    },
    "26": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda;
      return "                  <div class=\"col-sm-3 content-margin\">\n                    <div class=\"study-label\">Linked Proposal</div>\n                    <div class=\"\">\n                      <a href=\"" + escapeExpression((helpers.getter || depth0 && depth0.getter || helperMissing).call(depth0, depth0 != null ? depth0.proposal : depth0, "link", {
        "name": "getter",
        "hash": {},
        "data": data
      })) + "\" target=\"_blank\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.proposal : depth0) != null ? stack1.number : stack1, depth0)) + "<a/>\n                    </div>\n                    <div class=\"\">\n                      " + escapeExpression((helpers.getter || depth0 && depth0.getter || helperMissing).call(depth0, depth0 != null ? depth0.proposal : depth0, "leadDisplayName", {
        "name": "getter",
        "hash": {},
        "data": data
      })) + "\n                    </div>\n                    <div class=\"\">\n                      " + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.proposal : depth0) != null ? stack1.beginDate : stack1, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY"
        },
        "data": data
      })) + " - " + escapeExpression((helpers.moment || depth0 && depth0.moment || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.proposal : depth0) != null ? stack1.endDate : stack1, {
        "name": "moment",
        "hash": {
          'format': "MM/DD/YYYY"
        },
        "data": data
      })) + "\n                    </div>\n                    <div class=\"\">\n                      " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.proposal : depth0) != null ? stack1.status : stack1, depth0)) + "\n                    </div>\n                    <div>\n                      <a role=\"button\" tabindex=\"0\" class=\"study-unlink-proposal-btn\" data-id=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.proposal : depth0) != null ? stack1.id : stack1, depth0)) + "\">Unlink</a>\n                    </div>\n                  </div>\n";
    },
    "28": function _(depth0, helpers, partials, data) {
      return "              <div class=\"pull-left content-margin clearfix\" style=\"margin-right: 10px;\">\n                <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs study-link-proposal-btn wide-view\"><i class=\"fa-icon fa-icon-link pull-right\"></i>Link Proposal</div>\n              </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"study-overview-container\">\n    <div class=\"clearfix content-underline content-header content-page-width\">\n      <div class=\"navigation-header\">\n        <div class=\"rs-navigation-previous\">\n          <span class=\"glyphicon glyphicon-chevron-left\"></span>\n          " + escapeExpression((helper = (helper = helpers.previousPage || (depth0 != null ? depth0.previousPage : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "previousPage",
          "hash": {},
          "data": data
        }) : helper)) + "\n        </div>\n        <div class=\"rs-navigation-divider\"></div>\n        <div class=\"rs-navigation-title\">\n          <span class=\"large-title-text\">" + escapeExpression((helpers.t || depth0 && depth0.t || helperMissing).call(depth0, "Study.Details.Title", {
          "name": "t",
          "hash": {},
          "data": data
        })) + "</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"content-body content-table-padding-lg\">\n      <div class=\"study-info-container content-margin-large content-padding-top-xl\">\n        <div class=\"content-padding-lg content-margin-large\">\n\n          <div class=\"content-margin clearfix\">\n\n            <div class=\"study-title-container\">\n              <div class=\"pull-left pull-none-sm\">\n                <h2 class=\"no-margin\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "label",
          "hash": {},
          "data": data
        }) : helper)) + "&nbsp;</h2>\n              </div>\n\n              <div class=\"study-title-edit\">\n\n                <div class=\"editable-field study-title-view\">\n                  <h2 class=\"no-margin\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "title",
          "hash": {},
          "data": data
        }) : helper)) + "</h2>\n                  <span class=\"fa-icon fa-icon-pencil editable-field-icon\"></span>\n                </div>\n\n                <div class=\"editable-input study-title-input\">\n                  <input class=\"form-control\" value=\"" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "title",
          "hash": {},
          "data": data
        }) : helper)) + "\"/>\n\n                  <div class=\"study-title-error input-error\">\n                    <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n                    <div class=\"error-icon pull-left pull-none-sm\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n                    <span class=\"error-message\"></span>\n                  </div>\n\n                  <div class=\"btn-group editable-input-options\">\n                    <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs default\"><span class=\"fa-icon fa-icon-check\"></span></div>\n                    <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs default\"><span class=\"fa-icon fa-icon-times\"></span></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"clearfix\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.statusColor : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-lg-8\">\n              <div class=\"row\">\n                <div class=\"col-sm-3 content-margin ";
      stack1 = helpers.unless.call(depth0, (stack1 = depth0 != null ? depth0.contact : depth0) != null ? stack1.person : stack1, {
        "name": "unless",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " study-contact-details\">\n";
      stack1 = helpers['with'].call(depth0, (stack1 = depth0 != null ? depth0.contact : depth0) != null ? stack1.person : stack1, {
        "name": "with",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                </div>\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.organizations : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.sponsor : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n                <div class=\"col-sm-3 content-margin\">\n                  <div class=\"study-label\">Approval Date</div>\n                  <div class=\"study-field-value\" data-property=\"study.approvalDate\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.approvalDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.program(16, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                  </div>\n                </div>\n\n                <div class=\"col-sm-3 content-margin\">\n                  <div class=\"study-label\">Expiration Date</div>\n                  <div class=\"study-field-value\" data-property=\"study.expirationDate\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.expirationDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(18, data),
        "inverse": this.program(20, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                  </div>\n                </div>\n\n                <div class=\"col-sm-3 content-margin\">\n                  <div class=\"study-label\">Closed Date</div>\n                  <div class=\"study-field-value\" data-property=\"study.finalizedDate\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.finalizedDate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(22, data),
        "inverse": this.program(20, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                  </div>\n                </div>\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.reviewBoard : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(24, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.studyProposals : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(26, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n              </div>\n            </div>\n\n            <div class=\"col-lg-4\">\n              <div class=\"pull-left content-margin clearfix\" style=\"margin-right: 10px;\">\n                <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs new-document-btn wide-view\"><i class=\"fa-icon fa-icon-plus pull-right\"></i><span>Add</span></div>\n              </div>\n              <div class=\"pull-left content-margin clearfix\" style=\"margin-right: 10px;\">\n                  <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs study-create-pdf-btn wide-view\"><i class=\"fa-icon fa-icon-file pull-right\"></i><span>Create PDF</span></div>\n              </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canLinkProposals : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(28, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "              <div class=\"pull-left content-margin clearfix\" style=\"margin-right: 10px;\">\n                <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs study-delete-btn danger wide-view\"><i class=\"glyphicon glyphicon-remove pull-right\"></i>DELETE UNSUBMITTED STUDY</div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div>\n          <div class=\"content-margin content-padding-lg\">\n            <h2 class=\"no-margin content-indent-marker\">Key Study Contacts</h2>\n          </div>\n          <div class=\"assignment-list-container e3-table-tight\"></div>\n        </div>\n\n      </div>\n\n      <div class=\"clearfix\">\n        <div class=\"documents-container rs-collapse-menu-dark collapse-left open\" data-collapse-menu=\"auto\">\n          <div class=\"collapse-menu-absolute document-list-collapse\">\n            <div class=\"collapse-menu-closer\"><div class=\"collapse-menu-closer-icon\"></div></div>\n            <div class=\"document-list-container\"></div>\n          </div>\n          <div class=\"document-detail-container collapse-menu-static\"></div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n  <div class=\"clearfix\"></div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["study.detail.pdf"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "<span class=\"sub-heading\">Submission Type:</span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.doc : depth0) != null ? stack1.templateType : stack1, depth0));
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing;
      return "  <div class=\"sub-header\" style=\"padding:0px; border: 0px;\">\n    <div class=\"text-left default-color\">\n      <span class=\"sub-heading\">IRB #:</span><span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.doc : depth0) != null ? stack1.studyLabel : stack1, depth0)) + "</span></br>\n      <span class=\"sub-heading\">Title:</span><span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.doc : depth0) != null ? stack1.studyTitle : stack1, depth0)) + "</span></br>\n      <span class=\"sub-heading\">Creation Date:</span>" + escapeExpression((helper = (helper = helpers.createDate || (depth0 != null ? depth0.createDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "createDate",
        "hash": {},
        "data": data
      }) : helper)) + "<br/>\n      <span class=\"sub-heading\">Status:</span><span class=\"highlight\">" + escapeExpression((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "status",
        "hash": {},
        "data": data
      }) : helper)) + "</span><br/>\n      <span class=\"sub-heading\">Principal Investigator:</span>" + escapeExpression(lambda((stack1 = (stack1 = (stack1 = (stack1 = depth0 != null ? depth0.assignments : depth0) != null ? stack1.PRINCIPAL_INVESTIGATOR : stack1) != null ? stack1['0'] : stack1) != null ? stack1.person : stack1) != null ? stack1.displayName : stack1, depth0)) + "\n    </div>\n  </div>\n  <div class=\"pdf-form-container\"></div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "  <div class=\"sub-header\">\n    <div class=\"text-left default-color\">\n      <span class=\"sub-heading\">IRB #:</span><span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.study : depth0) != null ? stack1.label : stack1, depth0)) + "</span></br>\n      <span class=\"sub-heading\">Title:</span><span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.study : depth0) != null ? stack1.title : stack1, depth0)) + "</span></br>\n      <span class=\"sub-heading\">Creation Date:</span>" + escapeExpression((helper = (helper = helpers.createDate || (depth0 != null ? depth0.createDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "createDate",
          "hash": {},
          "data": data
        }) : helper)) + "<br/>      \n      <span class=\"sub-heading\">End Date:</span>" + escapeExpression((helper = (helper = helpers.expirationDate || (depth0 != null ? depth0.expirationDate : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "expirationDate",
          "hash": {},
          "data": data
        }) : helper)) + "<br/>\n      <span class=\"sub-heading\">Status:</span><span class=\"highlight\">" + escapeExpression((helpers.ProperCase || depth0 && depth0.ProperCase || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.study : depth0) != null ? stack1.state : stack1, {
          "name": "ProperCase",
          "hash": {},
          "data": data
        })) + "</span><br/>\n      <span class=\"sub-heading\">Principal Investigator:</span>" + escapeExpression(lambda((stack1 = (stack1 = (stack1 = (stack1 = depth0 != null ? depth0.assignmentsMap : depth0) != null ? stack1.PRINCIPAL_INVESTIGATOR : stack1) != null ? stack1['0'] : stack1) != null ? stack1.person : stack1) != null ? stack1.displayName : stack1, depth0)) + "<br/>\n      <span class=\"sub-heading\">Review Board:</span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.study : depth0) != null ? stack1.reviewBoard : stack1, depth0)) + "<br/>\n      <span class=\"sub-heading\">Sponsor:</span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.study : depth0) != null ? stack1.sponsor : stack1, depth0)) + "\n    </div>\n  </div>\n  <div class=\"group-list\">\n    <div class=\"group-header\" style=\"padding-left: 0px;\">Study History</div>\n    <div class=\"group-body\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.documents : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n  </div>\n  <div class=\"group-list\">\n    <div class=\"group-header\">Key Study Contacts</div>\n    <div class=\"group-body\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.assignments : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n  </div>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.documents : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <div class=\"group-item\">\n        <div class=\"item-prop\"><span class=\"prop-name\">Submission Type</span>" + escapeExpression((helper = (helper = helpers.templateType || (depth0 != null ? depth0.templateType : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "templateType",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n        <div class=\"item-prop\"><span class=\"prop-name\">Review Type</span>" + escapeExpression((helpers.ProperCase || depth0 && depth0.ProperCase || helperMissing).call(depth0, depth0 != null ? depth0.reviewType : depth0, {
        "name": "ProperCase",
        "hash": {},
        "data": data
      })) + "</div>\n        <div class=\"item-prop\"><span class=\"prop-name\">Decision</span><span class=\"highlight\">" + escapeExpression((helper = (helper = helpers.decisionStatus || (depth0 != null ? depth0.decisionStatus : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "decisionStatus",
        "hash": {},
        "data": data
      }) : helper)) + "</span></div>\n      </div>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "      <div class=\"group-item\">\n        <div class=\"item-prop\"><span class=\"prop-name\">Member</span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.person : depth0) != null ? stack1.displayName : stack1, depth0)) + "</div>\n        <div class=\"item-prop\"><span class=\"prop-name\">Role</span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.assignmentType : depth0) != null ? stack1.displayName : stack1, depth0)) + "</div>\n        <div class=\"item-prop\"><span class=\"prop-name\">Contact</span>" + escapeExpression(lambda((stack1 = (stack1 = depth0 != null ? depth0.person : depth0) != null ? stack1.primaryEmail : stack1) != null ? stack1.emailAddress : stack1, depth0)) + "</div>\n      </div>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <div class=\"group-list submission-group\">\n    <div class=\"group-header\">" + escapeExpression((helper = (helper = helpers.templateType || (depth0 != null ? depth0.templateType : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "templateType",
          "hash": {},
          "data": data
        }) : helper)) + " Submission</div>\n    <div class=\"pdf-form-container\" id=\"doc-id-";
      stack1 = (helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></div>\n  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"pdf-header\">\n  <div class=\"pull-left\">\n    <img class=\"header-logo\" src=\"data:image/png;base64,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\"/>\n  </div>\n  <div class=\"pull-right header-info\">\n    ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.doc : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n    <span class=\"sub-heading\">Date:</span>" + escapeExpression((helper = (helper = helpers.date || (depth0 != null ? depth0.date : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "date",
        "hash": {},
        "data": data
      }) : helper)) + "\n  </div>\n</div>\n<div class=\"pdf-body\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.doc : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["filter.option"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "checked";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<li>\n  <label>\n    <div class=\"col-xs-9 filter-option-txt\" title=\"" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "text",
          "hash": {},
          "data": data
        }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "displayName",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n    <div class=\"col-xs-3 text-right\">\n      <input class=\"filter-option-chkbx\" id=\"\" type=\"checkbox\" data-value=\"" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "text",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.checked : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">\n    </div>\n  </label>\n</li>";
    },
    "useData": true
  });
  this["RSTemplates"]["filter.popup"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div>\n  <ul class=\"filter-options\" data-index=\"" + escapeExpression((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "index",
        "hash": {},
        "data": data
      }) : helper)) + "\"></ul>\n</div>\n\n";
    },
    "useData": true
  });
  this["RSTemplates"]["study.list.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda;
      return "          <div class=\"tab-item\" data-name=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing;
      return "            <span class=\"filter-property\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"content-page-width\">\n  <div class=\"content-header content-underline content-page-width content-padding\">\n\n    <div class=\"clearfix\">\n\n      <div class=\"pull-right top-buttons\">\n        <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs new-study-btn wide-view\"><i class=\"fa-icon-plus pull-right\"></i>CREATE STUDY</div>\n      </div>\n\n      <div class=\"tab-container study-tabs large-title-text\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.tabs : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = this.invokePartial(partials['help.anchor'], '        ', 'help.anchor', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      </div>\n    </div>\n\n\n\n  </div>\n\n  <div class=\"content-body\">\n    <div class=\"form-new-study content-form\">\n      <div class=\"form-container\">\n        <div class=\"header clearfix\">\n          <span class=\"large-title-text pull-left\">New Study";
      stack1 = this.invokePartial(partials['help.anchor'], '', 'help.anchor', depth0 != null ? depth0.newStudy : depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</span>\n        </div>\n        <div class=\"row content-margin \">\n          <div class=\"col-sm-12\">\n            <label><i class=\"required\">*</i> Short Title:</label>\n            <input class=\"study-name form-control\" type=\"text\" />\n            <div class=\"study-name-error input-error\">\n              <span class=\"error-close right\"><i class=\"fa-icon-times\"></i></span>\n              <div class=\"error-icon pull-left\"><i class=\"fa-icon-exclamation-circle\"></i></div>\n              <span class=\"error-message\"></span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <span class=\"required\"><i class=\"required\">*</i> - Required</span>\n            <div class=\"pull-right\">\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-cancel-create-study\"><i class=\"fa-icon-ban pull-right\"></i>CANCEL</div>\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-save-create-study\"><i class=\"fa-icon-save pull-right\"></i>Save</div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content-bar-dark text-center\">\n      <div class=\"filter-bar\">\n        <div class=\"filter-bar-text\">Filter by: </div>\n        <div class=\"filter-bar-btn-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.propertyFilters : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        </div>\n      </div>\n      <div class=\"rs-filter-group pull-right\" style=\"margin-bottom: 5px;\">\n        <div role=\"button\" tabindex=\"0\" class=\"btn btn-xs btn-search pull-right\">search</div>\n\n        <i class=\"fa-icon-search\"></i>\n        <input type=\"search\" class=\"filter-input\" placeholder=\"Search\" />\n        <i class=\"fa-icon-times-circle filter-clear pull-right\"></i>\n      </div>\n    </div>\n    <div class=\"study-list-grid-container\"></div>\n    <div class=\"content-padding pagination-container clearfix text-center\" style=\"margin-top: 20px;\">\n\n      <span class=\"item-count\" style=\"line-height: 40px;\"></span>\n\n      <div class=\"pull-left form-inline\">\n        <div class=\"form-group page-count-select-container\">\n          <label for=\"\">Items per page &nbsp;</label>\n          <span id=\"count-select\"></span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["template.edit.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"form-create-container\"></div>";
    },
    "useData": true
  });
  this["RSTemplates"]["help.anchor"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <a class=\"help-anchor\" href=\"" + escapeExpression((helper = (helper = helpers.help || (depth0 != null ? depth0.help : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "help",
        "hash": {},
        "data": data
      }) : helper)) + "\" target=\"_blank\"><i class=\"fa-icon fa-icon-question-circle\"></i></a>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.help : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "useData": true
  });
  this["RSTemplates"]["multicolumn.button.row"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div style=\"width: " + escapeExpression((helper = (helper = helpers.width || (depth0 != null ? depth0.width : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "width",
        "hash": {},
        "data": data
      }) : helper)) + "px\" class='no-line grid-col'>\n	<div role=\"button\" tabindex=\"0\" class=\"btn btn-grid-col " + escapeExpression((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "class",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n		<span>" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span><span class='glyphicon glyphicon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + "'></span>\n	</div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["template.detail"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "disabled=\"disabled\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "<span role=\"button\" tabindex=\"0\" class=\"btn btn-primary wide-view light btn-save-template\"><i class=\"fa-icon fa-icon-pencil-square-o\"></i>SAVE</span>";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "<span role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-delete-template\"><i class=\"fa-icon fa-icon-trash-o\"></i>DELETE</span>";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <div class=\"data-rows-container content-margin\">\n                <div class=\"data-row template-item  ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-index=\"" + escapeExpression((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "index",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
      stack1 = helpers['with'].call(depth0, depth0 != null ? depth0.data : depth0, {
        "name": "with",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                </div>\n              </div>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      return "selected";
    },
    "12": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                    <div class=\"data-row-cell col-xs-3\">" + escapeExpression((helper = (helper = helpers.revisionNumber || (depth0 != null ? depth0.revisionNumber : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "revisionNumber",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n                    <div class=\"data-row-cell col-xs-5\">" + escapeExpression((helpers.calendar || depth0 && depth0.calendar || helperMissing).call(depth0, depth0 != null ? depth0.activityDate : depth0, {
          "name": "calendar",
          "hash": {},
          "data": data
        })) + "</div>\n                    <div class=\"data-row-cell col-xs-2 text-center\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n                    <div class=\"data-row-cell col-xs-2 text-center\">PUBLISHED</div>\n";
    },
    "13": function _(depth0, helpers, partials, data) {
      return "<span class=\"fa-icon fa-icon-lock\"></span>";
    },
    "15": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "              <div class=\"data-rows-container\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.revisions : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(16, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hasMore : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(19, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "              </div>\n";
    },
    "16": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                  <div class=\"data-row template-item ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-index=\"" + escapeExpression((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "index",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
      stack1 = helpers['with'].call(depth0, depth0 != null ? depth0.data : depth0, {
        "name": "with",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                  </div>\n";
    },
    "17": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                      <div class=\"data-row-cell col-xs-3\">" + escapeExpression((helper = (helper = helpers.revisionNumber || (depth0 != null ? depth0.revisionNumber : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "revisionNumber",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n                      <div class=\"data-row-cell col-xs-5\">" + escapeExpression((helpers.calendar || depth0 && depth0.calendar || helperMissing).call(depth0, depth0 != null ? depth0.activityDate : depth0, {
          "name": "calendar",
          "hash": {},
          "data": data
        })) + "</div>\n                      <div class=\"data-row-cell col-xs-2 text-center\">";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n                      <div class=\"data-row-cell col-xs-2 text-center\"></div>\n";
    },
    "19": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                  <div class=\"data-row\">\n                    <div class=\"data-row-cell clearfix\">\n                      <div class=\"pull-right\">\n                        " + escapeExpression((helper = (helper = helpers.pageNumber || (depth0 != null ? depth0.pageNumber : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "pageNumber",
          "hash": {},
          "data": data
        }) : helper)) + " of " + escapeExpression((helper = (helper = helpers.pageCount || (depth0 != null ? depth0.pageCount : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "pageCount",
          "hash": {},
          "data": data
        }) : helper)) + "\n                      </div>\n                      <span role=\"button\" tabindex=\"0\" style=\"cursor: pointer;\" class=\"previous-revisions-btn ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hasPrevious : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(20, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n                        <i class=\"fa-icon fa-icon-chevron-left content-margin-right\"></i>\n                      </span>\n                      &nbsp;&nbsp;&nbsp;\n                      <span role=\"button\" tabindex=\"0\" style=\"cursor: pointer;\" class=\"next-revisions-btn ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hasNext : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(20, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\">\n                        <i class=\"fa-icon fa-icon-chevron-right\"></i>\n                      </span>\n                    </div>\n                  </div>\n";
    },
    "20": function _(depth0, helpers, partials, data) {
      return "muted";
    },
    "22": function _(depth0, helpers, partials, data) {
      return "<span role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-edit-template-revision\"><i class=\"fa-icon fa-icon-pencil-square-o pull-right\"></i>EDIT</span>";
    },
    "24": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<span role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-delete-template-revision ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.canDelete : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.canDelete : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "><i class=\"fa-icon fa-icon-trash-o pull-right\"></i>DELETE</span>";
    },
    "25": function _(depth0, helpers, partials, data) {
      return "aria-disabled=\"true\"";
    },
    "27": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<span role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-publish-template-revision ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.canPublish : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.canPublish : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "><i class=\"fa-icon fa-icon-arrow-circle-up pull-right\"></i>PUBLISH</span>";
    },
    "29": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, (stack1 = (stack1 = depth0 != null ? depth0.selected : depth0) != null ? stack1.data : stack1) != null ? stack1.empty : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(30, data),
        "inverse": this.program(32, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "30": function _(depth0, helpers, partials, data) {
      return "              <div style=\"display: inline-block;\" title=\"Blank templates cannot be exported.\">\n                <a role=\"button\" tabindex=\"0\" class=\"btn btn-rs disabled wide-view\"><i class=\"fa-icon fa-icon-arrow-circle-o-down pull-right\"></i>EXPORT</a>\n              </div>\n";
    },
    "32": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <a href=\"" + escapeExpression((helper = (helper = helpers.download || (depth0 != null ? depth0.download : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "download",
        "hash": {},
        "data": data
      }) : helper)) + "\" role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view\"><i class=\"fa-icon fa-icon-arrow-circle-o-down pull-right\"></i>EXPORT</a>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        helperMissing = helpers.helperMissing,
        buffer = "<td colspan=\"3\" class=\"template-details content-details-form form-update-template\">\n  <div class=\"template-details-header content-padding details-padding\">\n    Template Info\n  </div>\n  <div class=\"template-details-body form-container content-padding details-padding\">\n    <div class=\"row\">\n      <div class=\"col-sm-4\">\n        <div class=\"margin\">Title:</div>\n        <div class=\"content-margin\">\n          <input ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPerm : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  class=\"template-input template-title ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPerm : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" type=\"text\" value=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.latest : depth0) != null ? stack1.title : stack1, depth0)) + "\">\n          <div class=\"template-title-error input-error\">\n            <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n            <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n            <span class=\"error-message\"></span>\n          </div>\n        </div>\n        <div class=\"margin\">Description:</div>\n        <div class=\"content-margin\">\n          <textarea ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPerm : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " class=\"no-resize template-input template-description ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.modifyPerm : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" rows=\"5\" style=\"resize: no-resize; width: 100%:\">" + escapeExpression((helpers.brToNewLine || depth0 && depth0.brToNewLine || helperMissing).call(depth0, (stack1 = depth0 != null ? depth0.latest : depth0) != null ? stack1.description : stack1, {
        "name": "brToNewLine",
        "hash": {},
        "data": data
      })) + "</textarea>\n        </div>\n        <div class=\"template-revision-actions content-margin btn-rs-group\">\n          ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.modifyPerm : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n          ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.deletePerm : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n      <div class=\"col-sm-8\">\n          <div class=\"rs-simple-table revision-list content-margin dark\">\n            <div class=\"data-header\">\n              <div class=\"data-header-cell col-xs-3\">Revision</div>\n              <div class=\"data-header-cell col-xs-3\">Save Date</div>\n            </div>\n";
      stack1 = helpers['with'].call(depth0, depth0 != null ? depth0.published : depth0, {
        "name": "with",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.revisions : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </div>\n          <div class=\"template-revision-actions content-margin btn-rs-group\">\n            ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.modifyPerm : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(22, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n            ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.deletePerm : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(24, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n            ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.publishPerm : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(27, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n            <span role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-preview-template-revision\"><i class=\"fa-icon fa-icon-eye pull-right\"></i>PREVIEW</span>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.download : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(29, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "          </div>\n      </div>\n    </div>\n  </div>\n</td>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["template.detail.revision.row"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"data-row ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-id=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">\n	<div>" + escapeExpression((helper = (helper = helpers.revisionNumber || (depth0 != null ? depth0.revisionNumber : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "revisionNumber",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n	<div>" + escapeExpression((helpers.dateFormat || depth0 && depth0.dateFormat || helperMissing).call(depth0, depth0 != null ? depth0.activityDate : depth0, {
        "name": "dateFormat",
        "hash": {
          'format': "l"
        },
        "data": data
      })) + "</div>\n	<div>";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n	<div>";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.published : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n</div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "selected";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "<span class=\"glyphicon glyphicon-lock\"></span>";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "<span class=\"glyphicon glyphicon-certificate\"></span>";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.rows : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "useData": true
  });
  this["RSTemplates"]["template.list.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-create-template pull-right\"><i class=\"fa-icon fa-icon-plus\"></i> CREATE TEMPLATE</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "            <option value=\"" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content-page-width full-height\">\n  <div class=\"clearfix content-underline padding content-header content-padding content-page-width\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canCreate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    <div class=\"rs-header-title\">\n      <span role=\"heading\" aria-level=\"2\" class=\"large-title-text\">Manage " + escapeExpression((helpers.ProperCase || depth0 && depth0.ProperCase || helperMissing).call(depth0, depth0 != null ? depth0.documentType : depth0, {
        "name": "ProperCase",
        "hash": {},
        "data": data
      })) + " Templates</span>\n    </div>\n  </div>\n  <div class=\"form-new-template content-form\">\n    <div class=\"form-container content-underline-top\">\n      <div class=\"header clearfix\">\n        <span role=\"heading\" aria-level=\"2\" class=\"large-title-text pull-left\">Creating a New Template</span>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <span class=\"required\">*</span> Title:\n          <input class=\"template-title form-control\" type=\"text\" />\n          <div class=\"template-title-error input-error\">\n            <span class=\"error-close right\"><i class=\"fa-icon fa-icon-remove\"></i></span>\n            <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-sign\"></i></div>\n            <span class=\"error-message\"></span>\n          </div>\n        </div>\n        <div class=\"col-sm-6\">\n          <span class=\"required\">*</span> Type:\n          <select class=\"template-type form-control\">\n            <option value=\"\">Select a Template Type</option>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.templateTypes : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </select>\n          <div class=\"template-type-error input-error\">\n            <span class=\"error-close right\"><i class=\"fa-icon fa-icon-remove\"></i></span>\n            <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-sign\"></i></div>\n            <span class=\"error-message\"></span>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          Description:\n          <textarea class=\"template-description col-sm-12 form-control no-resize\" rows=\"5\"></textarea>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <div>\n            Import:\n          </div>\n          <div class=\"input-group form-group has-feedback\">\n          <span style=\"z-index: 10; top: 9px; cursor: pointer\" role=\"button\" aria-label=\"clear files\" tabindex=\"0\" class=\"fa-icon fa-icon-times form-control-feedback clear-template-import\"></span>\n            <span class=\"input-group-btn\">\n              <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs template-import\" style=\"overflow: hidden;\">\n                CHOOSE FILE\n";
      stack1 = this.invokePartial(partials['hidden.fileinput'], '                ', 'hidden.fileinput', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "              </div>\n            </span>\n            <div>\n              <input type=\"text\" class=\"has-feedback form-control import-template-display\" disabled=\"disabled\"></input>\n            </div>\n\n          </div>\n\n        </div>\n      </div>\n      <div class=\"clearfix\">\n        <div class=\"pull-right\">\n        </div>\n        <div class=\"pull-left bottom-buttons\">\n          <span class=\"required\">* - Required</span>\n        </div>\n        <div class=\"pull-right top-buttons\">\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-cancel-create-template\"><i class=\"fa-icon fa-icon-ban-circle pull-right\"></i> CANCEL</div>\n          <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view btn-save-create-template\"><i class=\"fa-icon fa-icon-save pull-right\"></i> SAVE</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"content-bar-dark content-underline-top\">\n    <div class=\"rs-filter-group pull-right\" style=\"margin-bottom: 5px;\">\n      <i class=\"fa-icon fa-icon-search\"></i>\n      <input type=\"text\" class=\"filter-input\" placeholder=\"Filter\" />\n      <i class=\"fa-icon fa-icon-times-circle filter-clear pull-right\"></i>\n    </div>\n\n  </div>\n  <div class=\"content-body template-list-container\">\n    <div class=\"template-list-grid-container use-highlight use-selected-carrot\"></div>\n  </div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["authenticate.forgot"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "password";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "			<div class=\"row\"><input class=\"form-control forgot-inputs col-md-12 username-entry\" placeholder=\"Please enter your username.\"  type=\"text\" /></div>\n			<div class=\"row\">\n	      <div class=\"user-input-error input-error\">\n	        <div class=\"error-icon pull-left\">\n	          <div class=\"sprite-exclamation\"></div>\n	        </div>\n	        <span class=\"error-message\"></span>\n	      </div>\n			</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"forgot-popover ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.forgotPassword : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n	<div class=\"form\">\n		<div class=\"row\"><input class=\"form-control forgot-inputs col-md-12 email-entry\" placeholder=\"Please enter your email address.\" type=\"text\" /></div>\n		<div class=\"row\">\n      <div class=\"email-input-error input-error\">\n        <div class=\"error-icon pull-left\">\n          <div class=\"sprite-exclamation\"></div>\n        </div>\n        <span class=\"error-message\">The information provided is invalid.</span>\n      </div>\n		</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.forgotPassword : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "		<div class=\"row\"><a role=\"button\" tabindex=\"0\" class=\"forgot-submit col-md-6 btn btn-primary pull-right\">Submit</a></div>\n		<div class=\"clear\"></div>\n	</div>\n	<div class=\"response\">\n		Please check your email for help on obtaining your login information.\n	</div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["authenticate.fpv"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div>\n  <div class=\"col-md-4\"></div>\n  <div class=\"col-md-4\">\n    <div class=\"evisions-logo\"></div>\n    <div class=\"research-logo\"></div>\n    <div class=\"login-text\">reset password</div>\n  </div>\n  <div class=\"clear\"></div>\n</div>\n<div class=\"login-stripe\">\n  <div class=\"col-md-4\"></div>\n  <!-- Message Field -->\n  <div class=\"col-md-4 message-container\">\n    <span>Verifying request...</span>\n  </div>\n  <!-- Forgot Password Fields -->\n  <div style=\"display:none\" class=\"col-md-4 field-container\">\n    <div class=\"reset-error input-error alert alert-danger\">The entered passwords do not match.</div>\n    <!-- Email Input Field -->\n    <div class=\"form-group\">\n      <label>new password</label>\n      <div class=\"reset-password-error input-error alert alert-danger\"></div>\n      <input type=\"password\" class=\"form-control password-input resetpw-inputs\" placeholder=\"Please enter your password\">\n      <div class=\"clear\"></div>\n    </div>\n    <!-- Passowrd Input Field -->\n    <div class=\"form-group\">\n      <label>re-enter password</label>\n      <div class=\"reset-repassword-error input-error alert alert-danger\"></div>\n      <input type=\"password\" class=\"form-control repassword-input resetpw-inputs\" placeholder=\"Please re-enter your password\">\n      <div class=\"clear\"></div>\n    </div>\n    <!-- Login Button -->\n    <div class=\"loadingSpinnerSmall pull-left\"></div>\n    <div class=\"clear\"></div>\n  </div>\n  <div class=\"clear\"></div>\n</div>\n<div class=\"footer-stripe\">\n  <div class=\"col-md-4\"></div>\n  <div class=\"col-md-4\">\n    <a role=\"button\" tabindex=\"0\" class=\"btn btn-primary pull-right fpv-save\" style=\"display:none\">Save</a>\n  </div>\n  <div class=\"clear\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["authenticate.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing;
      return "              <option value=" + escapeExpression(lambda(data && data.index, depth0)) + ">" + escapeExpression((helper = (helper = helpers.username || (depth0 != null ? depth0.username : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "username",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "          <div style=\"display: block\" class=\"login-error input-error shadow no-caret\">\n            <div class=\"error-icon pull-left\">\n              <i class=\"fa-icon fa-icon-exclamation-circle\"></i>\n            </div>\n            <span class=\"error-message\">test" + escapeExpression((helper = (helper = helpers.logoutReason || (depth0 != null ? depth0.logoutReason : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "logoutReason",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n          </div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "checked";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div>\n  <div class=\"col-md-6 col-md-offset-3\">\n    <div class=\"research-logo\"></div>\n    <div class=\"login-text\">login</div>\n  </div>\n  <div class=\"clear\"></div>\n</div>\n<div class=\"login-stripe\">\n  <div class=\"col-md-6 col-md-offset-3\">\n\n    <div class=\"row\">\n      <div class=\"col-lg-5\">\n        <div class=\"form-group\">\n          <label>Preset User</label>\n          <select class=\"form-control preset-user-select\">\n            <option selected=\"selected\">Select a preset user</option>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.presetUsers : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          </select>\n        </div>\n      </div>\n\n      <div class=\"col-lg-2 text-center\">\n        <div class=\"visible-lg-inline-block vertical-divider\"></div>\n        <div class=\"hidden-lg horizontal-divider\"></div>\n      </div>\n\n      <div class=\"col-lg-5\">\n        <div class=\"form-group\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.logoutReason : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n          <label>Username</label>\n          <input tabindex=\"1\" value=\"" + escapeExpression((helper = (helper = helpers.username || (depth0 != null ? depth0.username : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "username",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"form-control username-input\" autocapitalize=\"off\" autocorrect=\"off\" autocomplete=\"off\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "shadow username"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "shadow login"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n        <div class=\"form-group\">\n          <label>Password</label>\n          <input tabindex=\"2\" value=\"" + escapeExpression((helper = (helper = helpers.password || (depth0 != null ? depth0.password : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "password",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"form-control password-input\" type=\"password\" autocapitalize=\"off\" autocorrect=\"off\" autocomplete=\"off\" />\n          ";
      stack1 = (helpers.inject || depth0 && depth0.inject || helperMissing).call(depth0, "form.control.validation", {
        "name": "inject",
        "hash": {
          'validationName': "shadow password"
        },
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        </div>\n      </div>\n    </div>\n\n    <div class=\"choose-tenant-container\">\n      <div>Choose Tenant:</div>\n      <div class=\"editable-field\">\n        <span role=\"button\" tabindex=\"0\" class=\"btn btn-link\">" + escapeExpression((helper = (helper = helpers.tenant || (depth0 != null ? depth0.tenant : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tenant",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n        <span class=\"fa-icon fa-icon-pencil editable-field-icon\"></span>\n      </div>\n      <div class=\"editable-input\" style=\"display: none\">\n        <input class=\"form-control tenant-input\" value=\"" + escapeExpression((helper = (helper = helpers.tenant || (depth0 != null ? depth0.tenant : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "tenant",
        "hash": {},
        "data": data
      }) : helper)) + "\"/>\n      </div>\n    </div>\n\n    <!-- Login Button -->\n    <div class=\"loadingSpinnerSmall pull-left\"></div>\n    <div class=\"clear\"></div>\n  </div>\n  <div class=\"clear\"></div>\n</div>\n<div class=\"footer-stripe\">\n  <div class=\"col-md-6 col-md-offset-3\">\n    <a role=\"button\" tabindex=\"4\" class=\"btn btn-primary pull-right login\">LOG IN</a>\n    <span class=\"remember-me-control\">\n      <input tabindex=\"3\" type=\"checkbox\" id=\"remember-me\" class=\"remember-me-input\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.username : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "></input>\n      <label for=\"remember-me\">Remember Me</label>\n    </span>\n  </div>\n  <div class=\"clear\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["calendar"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"rs-calendar-container\"></div>";
    },
    "useData": true
  });
  this["RSTemplates"]["checklist.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "    <select class=\"multiple-checklist-selector form-control\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.checklists : depth0, depth0 != null ? depth0.selChecklist : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </select>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "      <option value=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" ";
      stack1 = helpers['if'].call(depth0, data && data.selected, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + " (" + escapeExpression((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "type",
        "hash": {},
        "data": data
      }) : helper)) + ")</option>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "selected";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "checklist-dropdown";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"checklist-closer\">\n  <span class=\"checklist-closer-icon\"></span>\n</div>\n\n<div class=\"checklist-header\">\n  <span class=\"checklist-title\">Checklist</span>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.multipleChecklists : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n\n<div class=\"checklist-form-container ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.multipleChecklists : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></div>\n\n\n<div class=\"checklist-footer clearfix\">\n  <div role=\"button\" tabindex=\"0\" class=\"btn btn-primary btn-checklist-save pull-right\"><i class=\"fa-icon fa-icon-save\"></i> Save Checklist</div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["e3-pagination"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "hidden";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "nav-icon";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['with'].call(depth0, depth0 != null ? depth0.previousPlaceholder : depth0, {
        "name": "with",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "8": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "      <li class=\"e3-page\">\n        <a ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.page : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "><span aria-hidden=\"true\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</span></a>\n      </li>\n      <li class=\"no-click\" data-action=\"previous-placeholder\">\n        <span>...</span>\n      </li>\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "data-page=\"" + escapeExpression((helper = (helper = helpers.page || (depth0 != null ? depth0.page : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "page",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "href=\"" + escapeExpression((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "link",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "13": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "      <li class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.active : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " e3-page\">\n        <a ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.page : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " aria-label=\"Previous\"><span aria-hidden=\"true\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</span></a>\n      </li>\n";
    },
    "14": function _(depth0, helpers, partials, data) {
      return "active";
    },
    "16": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['with'].call(depth0, depth0 != null ? depth0.nextPlaceholder : depth0, {
        "name": "with",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "17": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "      <li class=\"no-click\" data-action=\"next-placeholder\">\n        <span>...</span>\n      </li>\n      <li class=\"e3-page\">\n        <a ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.page : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "><span aria-hidden=\"true\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</span></a>\n      </li>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<nav class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hidden : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n  <ul class=\"pagination\">\n    <li class=\"";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.canGoPrevious : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n      <a aria-label=\"Previous\" data-action=\"prev\"><span aria-hidden=\"true\"><i class=\"fa-icon fa-icon-chevron-left\"></i></span></a>\n    </li>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.previousPlaceholder : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.pages : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.nextPlaceholder : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(16, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    <li class=\"";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.canGoNext : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\">\n      <a aria-label=\"Next\" data-action=\"next\"><span aria-hidden=\"true\"><i class=\"fa-icon fa-icon-chevron-right\"></i></span></a>\n    </li>\n  </ul>\n</nav>";
    },
    "useData": true
  });
  this["RSTemplates"]["editable.input"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"editable-field\">\n  <span>" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n  <span class=\"fa-icon fa-icon-pencil editable-field-icon\"></span>\n</div>\n\n<div class=\"editable-input\" data-field=" + escapeExpression((helper = (helper = helpers.field || (depth0 != null ? depth0.field : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "field",
        "hash": {},
        "data": data
      }) : helper)) + ">\n  <input class=\"form-control\" value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "\"/>\n\n  <div class=\"" + escapeExpression((helper = (helper = helpers.field || (depth0 != null ? depth0.field : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "field",
        "hash": {},
        "data": data
      }) : helper)) + "-error input-error\">\n    <span class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></span>\n    <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\n    <span class=\"error-message\"></span>\n  </div>\n\n  <div class=\"btn-group editable-input-options\">\n    <div role=\"button\" tabindex=\"0\" class=\"btn btn-default\" data-option=\"confirm\"><span class=\"fa-icon fa-icon-check\"></span></div>\n    <div role=\"button\" tabindex=\"0\" class=\"btn btn-default\" data-option=\"cancel\"><span class=\"fa-icon fa-icon-times\"></span></div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["error.init.template"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div style=\"max-height: 500px; overflow:auto\" class=\"error-messages-container\">\n\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["error.message.template"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<hr class=\"modal-row-sep\" />\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "        <br>Error code: <span class=\"fixed-width-font\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.stackTraceCode : stack1, depth0)) + "</span><br><br>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "        <a role=\"button\" tabindex=\"0\" href=\"#\" class=\"btn-show-error-details\">Show Error Details</a>\n        <div class=\"error-details\">\n            <br />\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.summary : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.requestMethod : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.requestUrl : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.stackTraceCode : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.stackTrace : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        </div>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                Summary: " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.summary : stack1, depth0)) + "<br /><br />\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                Request Method: " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.requestMethod : stack1, depth0)) + "<br />\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                Request URL: " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.requestUrl : stack1, depth0)) + "<br /><br />\n";
    },
    "12": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                Stack Trace Code: " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.stackTraceCode : stack1, depth0)) + "<br />\n";
    },
    "14": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "                Please copy and include the following Error Info into your Support ticket.<br /><br />\n                Error Info:<br />\n                <textarea style=\"resize: vertical\" class=\"box-stack-trace\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.stackTrace : stack1, depth0)) + "</textarea><br /><br />\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.first : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<div>\n  ";
      stack1 = (helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "message",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<br />\n\n    <br />\n    Please contact your system administrator if this error continues to occur.\n";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.details : depth0) != null ? stack1.stackTraceCode : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n  <br />\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.details : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.diff.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"form-wrapper\">\n  <div class=\"form-section-container\">\n  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.diff.section.row"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div role=\"menuitem\" tabindex=\"0\" class=\"form-sidebar-section\">\n  <div class=\"section-text\">\n    <span class=\"badge pull-right\">" + escapeExpression((helper = (helper = helpers.count || (depth0 != null ? depth0.count : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "count",
        "hash": {},
        "data": data
      }) : helper)) + " <span class=\"accessibility-text\">comparisons in this section</span></span>\n    <span class=\"section-label\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["attach.document"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <input type=\"radio\" class=\"attachment-compare-selector\" style=\"display: none;\"\n    value=\"{&quot;docStoreId&quot;: &quot;/rs/api/docstore/" + escapeExpression((helper = (helper = helpers.docstoreId || (depth0 != null ? depth0.docstoreId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "docstoreId",
        "hash": {},
        "data": data
      }) : helper)) + "&quot;, &quot;fileName&quot;: &quot;" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "&quot; }\">\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "url";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "file";
    },
    "9": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <a target=\"_blank\" class=\"link-attachment\" href=\"" + escapeExpression((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "url",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <a href=\"/rs/api/docstore/" + escapeExpression((helper = (helper = helpers.docstoreId || (depth0 != null ? depth0.docstoreId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "docstoreId",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"file-attachment\" target=\"_blank\">\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.url : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<label>\n  <div class=\"attachment-object ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.url : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.program(7, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" title=\"" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n    <div class=\"attachment-text\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.program(11, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n      </a>\n    </div>\n    <div role=\"button\" tabindex=\"0\" data-attachment-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\" aria-label=\"remove attachment " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"attachment-remove\"></div>\n  </div>\n</label>\n<br>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["attach.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "aria-disabled=\"true\"";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "elementId",
        "hash": {},
        "data": data
      }) : helper)) + "-message\" class=\"accessibility-text\">, required</div>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "	<div role=\"button\" tabindex=\"0\" class=\"compare-button\" aria-disabled=\"true\">\n	   <i class=\"fa-icon fa-icon-columns\"></i>Compare Attachments\n	</div>\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "  		Sample documents:\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.samples : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.id : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.program(13, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.displayName : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.program(17, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  			</a>\n";
      stack1 = helpers.unless.call(depth0, data && data.last, {
        "name": "unless",
        "hash": {},
        "fn": this.program(22, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  					<a href=\"/rs/api/docstore/" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "13": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  					<a target=\"_blank\" href=\"" + escapeExpression((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "url",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "15": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  					" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "17": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.fileName : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(18, data),
        "inverse": this.program(20, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "18": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    					" + escapeExpression((helper = (helper = helpers.fileName || (depth0 != null ? depth0.fileName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "fileName",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "20": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              " + escapeExpression((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "url",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "22": function _(depth0, helpers, partials, data) {
      return "  			,&nbsp;\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div style=\"min-height: 32px;\">\n  <div class=\"btn-attachment-container clearfix\">\n    <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs centered btn-attach btn-attachment pull-left ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n      Attach\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.required : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n  </div>\n  <div class=\"pull-left attachment-display\">\n  </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.diffViewer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  <div class=\"clearfix\"></div>\n  <div class=\"sample-docs-box\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.samples : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["check.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "checked=\"checked\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "required=\"true\" aria-required=\"true\"";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "disabled=\"true\" aria-disabled=\"true\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<table role=\"presentation\" style=\"width: 100%;\">\n  <tr>\n    <td style=\"width: 1%;\" valign=\"top\">\n      <input\n        type=\"checkbox\"\n        id=\"fo-" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "id",
          "hash": {},
          "data": data
        }) : helper)) + "-control\"\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.value : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.parentIsRequired : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "/>\n    </td>\n    <td>\n      <label data-property=\"text\" data-type=\"rich\" class=\"editable editable-input\" for=\"fo-" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "-control\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</label>\n    </td>\n  </tr>\n</table>\n<div class=\"form-object-controls-container\"></div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["datepicker.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "required=\"true\" aria-required=\"true\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "disabled=\"true\" aria-disabled=\"true\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"clearfix\">\n	<div class=\"datepicker-input-container\">\n	  <input\n			id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-control\"\n			placeholder=\"" + escapeExpression((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "placeholder",
          "hash": {},
          "data": data
        }) : helper)) + "\"\n			type=\"text\"\n			data-date-autoclose=\"true\"\n			data-date-start-view=\"1\"\n			data-provide=\"datepicker\"\n			style=\"width: 200px;\"\n			class=\"\"\n			value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "value",
          "hash": {},
          "data": data
        }) : helper)) + "\"\n			";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.required : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n			";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " />\n	  <i class=\"fa-icon fa-icon-calendar\"></i>\n	</div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["formobject.content"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<span class=\"is-required\" aria-hidden=\"true\">*</span><span class=\"accessibility-text\">required</span>";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "form-margin-medium";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hideLabel : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "          <!-- If label does not exist, in designer, we must be able to show placeholder text -->\n          <td style=\"width: 1%; padding-right: 20px;\" valign=\"top\">\n            <div>\n              <div data-maxlength=\"10\" class=\"form-object-label editable editable-input\" data-property=\"label\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n            </div>\n          </td>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.label : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "9": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <td style=\"width: 1%; padding-right: 20px;\" valign=\"top\">\n                <div>\n                  <div data-maxlength=\"10\" class=\"form-object-label\" data-property=\"label\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n                </div>\n              </td>\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "            <label for=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-control\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.extra : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n              <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "elementId",
        "hash": {},
        "data": data
      }) : helper)) + "-text\" class=\"form-object-text editable editable-input\"  data-type=\"rich\" data-property=\"text\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n            </label>\n";
    },
    "12": function _(depth0, helpers, partials, data) {
      return "class=\"form-margin-medium\"";
    },
    "14": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.designer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "15": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <label for=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-control\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.extra : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n                <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "elementId",
        "hash": {},
        "data": data
      }) : helper)) + "-text\" class=\"form-object-text editable editable-input\"  data-type=\"rich\" data-property=\"text\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n              </label>\n";
    },
    "17": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "            <div>\n              ";
      stack1 = (helper = (helper = helpers.extra || (depth0 != null ? depth0.extra : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "extra",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n            </div>\n";
    },
    "19": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hideDescription : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(20, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "20": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <div class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.extra : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " form-object-description-container\">\n                <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "elementId",
        "hash": {},
        "data": data
      }) : helper)) + "-description\" class=\"form-object-description editable editable-input description\"  data-type=\"rich\" data-property=\"description\">";
      stack1 = (helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n              </div>\n";
    },
    "22": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.description : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(23, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n";
    },
    "23": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <div class=\"form-object-description-container\">\n                <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-description\" class=\"form-object-description\">";
      stack1 = (helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n              </div>\n";
    },
    "25": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "              <div role=\"button\"\n                   aria-label=\"" + escapeExpression((helper = (helper = helpers.ariaLabel || (depth0 != null ? depth0.ariaLabel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "ariaLabel",
          "hash": {},
          "data": data
        }) : helper)) + "\"\n                   tabindex=\"0\"\n                   class=\"helptext-button ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.helpText : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(26, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"\n                   data-trigger=\"click\"\n                   data-toggle=\"popover\"\n                   data-html=\"true\"\n                   data-placement=\"left\"\n                   data-content=\"" + escapeExpression((helper = (helper = helpers.helpText || (depth0 != null ? depth0.helpText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "helpText",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n                <i class=\"fa-icon fa-icon-question-circle\"></i>\n              </div>\n";
    },
    "26": function _(depth0, helpers, partials, data) {
      return "empty-helptext";
    },
    "28": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.helpText : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(29, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n";
    },
    "29": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "              <div role=\"button\"\n                   tabindex=\"0\"\n                   aria-label=\"" + escapeExpression((helper = (helper = helpers.ariaLabel || (depth0 != null ? depth0.ariaLabel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "ariaLabel",
        "hash": {},
        "data": data
      }) : helper)) + "\"\n                   class=\"helptext-button\"\n                   data-trigger=\"click\"\n                   data-toggle=\"popover\"\n                   data-html=\"true\"\n                   data-placement=\"left\"\n                   data-content=\"" + escapeExpression((helper = (helper = helpers.helpText || (depth0 != null ? depth0.helpText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "helpText",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n                <i class=\"fa-icon fa-icon-question-circle\"></i>\n              </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.required : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n<div class=\"form-object-element clearfix ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.margin : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" style=\"width: 100%; overflow-x: auto; overflow-y: hidden;\">\n  <table role=\"presentation\" style=\"width: 100%;\">\n    <tr>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.designer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.program(8, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      <td valign=\"top\">\n        <div style=\"width: 100%;\" class=\"form-object-controls-container\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.program(14, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.extra : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.designer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(19, data),
        "inverse": this.program(22, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "          <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "elementId",
        "hash": {},
        "data": data
      }) : helper)) + "-controlWrapper\" class=\"form-object-content-controls\" style=\"width: 100%;\">\n          </div>\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.designer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.program(28, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        </div>\n      </td>\n    </tr>\n  </table>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["formobject.controls"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <div class=\"form-object-controls\">\n    <div role=\"button\" tabindex=\"0\" aria-label=\"discard\" class=\"trash glyphicon glyphicon-trash\"></div>\n    <div role=\"button\" tabindex=\"0\" aria-label=\"drag to new position\" class=\"dragger glyphicon glyphicon-align-justify\"></div>\n  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.designer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["RSTemplates"]["formobject.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "is-group";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.compoundType : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "4": function _(depth0, helpers, partials, data) {
      var helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "	<div role=\"button\" tabindex=\"0\" class=\"btn-add-compound btn btn-rs pull-right\">\n		<span class=\"glyphicon glyphicon-plus\"></span>\n		<span>ADD " + escapeExpression((helpers.UpperCase || depth0 && depth0.UpperCase || helperMissing).call(depth0, depth0 != null ? depth0.compoundType : depth0, {
        "name": "UpperCase",
        "hash": {},
        "data": data
      })) + "</span>\n	</div>\n	<div class=\"clearfix\"></div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = this.invokePartial(partials['formobject.controls'], '', 'formobject.controls', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<div class=\"form-object-contents clearfix ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.group : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" style=\"width: 100%;\">\n";
      stack1 = this.invokePartial(partials['formobject.content'], '  ', 'formobject.content', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n<div class=\"form-object-children-container indent\"></div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.designer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["label.formobject"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "";
    },
    "useData": true
  });
  this["RSTemplates"]["person.finder.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "aria-disabled=\"true\"";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "          <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "elementId",
        "hash": {},
        "data": data
      }) : helper)) + "-message\" class=\"accessibility-text\">, required</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-control\">\n  <div style=\"width: 100%;\">\n    <div class=\"clearfix person-finder-btn-container\">\n      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs centered btn-person-finder pull-left ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n        Find People\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.required : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "      </div>\n    </div>\n  </div>\n  <div class=\"clearfix\" style=\"width: 100%;\">\n    <div class=\"pull-left person-finder-display e3-table-md-responsive e3-table-tight\" style=\"width: 100%;\"></div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["person.finder.formobject.pdf"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "    <div class=\"\" ";
      stack1 = helpers.unless.call(depth0, data && data.last, {
        "name": "unless",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.cells : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "style=\"margin-bottom: 10px\"";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.column : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <span style=\"margin-right: 5px; color: black;\">" + escapeExpression((helper = (helper = helpers.column || (depth0 != null ? depth0.column : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "column",
        "hash": {},
        "data": data
      }) : helper)) + ":</span>" + escapeExpression((helper = (helper = helpers.content || (depth0 != null ? depth0.content : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "content",
        "hash": {},
        "data": data
      }) : helper)) + "<br/>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.items : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["person.finder.formobject.row"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"clearfix\">\n	<span class=\"pull-left\">\n		" + escapeExpression((helper = (helper = helpers.lastName || (depth0 != null ? depth0.lastName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lastName",
        "hash": {},
        "data": data
      }) : helper)) + ", " + escapeExpression((helper = (helper = helpers.firstName || (depth0 != null ? depth0.firstName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "firstName",
        "hash": {},
        "data": data
      }) : helper)) + "\n	</span>\n        <span class=\"glyphicon glyphicon-remove remove-person-finder pull-right\"></span>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["radio.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "checked=\"checked\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "required=\"true\" aria-required=\"true\"";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "disabled=\"true\" aria-disabled=\"true\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<table role=\"presentation\" style=\"width: 100%;\">\n  <tr>\n    <td style=\"width: 1%;\" valign=\"top\">\n      <input\n        name=\"" + escapeExpression((helper = (helper = helpers.radioGroup || (depth0 != null ? depth0.radioGroup : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "radioGroup",
          "hash": {},
          "data": data
        }) : helper)) + "\"\n        type=\"radio\"\n        id=\"fo-" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "id",
          "hash": {},
          "data": data
        }) : helper)) + "-control\"\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.value : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.parentIsRequired : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "/>\n    </td>\n    <td>\n      <label class=\"editable editable-input\" data-property=\"text\" data-type=\"rich\" for=\"fo-" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "-control\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</label>\n    </td>\n  </tr>\n</table>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["sponsor.finder.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "aria-disabled=\"true\"";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "elementId",
        "hash": {},
        "data": data
      }) : helper)) + "-message\" class=\"accessibility-text\">, required</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div style=\"width: 100%;\">\n  <div class=\"clearfix sponsor-finder-btn-container\">\n    <div id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-control\" role=\"button\" tabindex=\"0\" class=\"btn btn-rs centered btn-sponsor-finder pull-left ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n      Find Sponsors\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.required : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n  </div>\n</div>\n<div class=\"clearfix\" style=\"width: 100%;\">\n  <div class=\"pull-left sponsor-finder-display e3-table-md-responsive e3-table-tight\">\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["sponsor.finder.formobject.row"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"clearfix\">\n	<span class=\"pull-left\">\n		" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\n	</span>\n	<span class=\"glyphicon glyphicon-remove remove-sponsor-finder pull-right\"></span>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["textarea.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "required=\"true\" aria-required=\"true\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "disabled=\"true\" aria-disabled=\"true\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div>\n  <textarea\n    id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-control\"\n    class=\"col-md-6 col-sm-12 visual-diff-support\"\n    ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.required : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n    ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "></textarea>\n  <div class=\"clearfix\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["textbox.formobject"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "height: 35px;";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "height: 26px;";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "required=\"true\" aria-required=\"true\"";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "disabled=\"true\" aria-disabled=\"true\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"clearfix\">\n<textarea\n  id=\"" + escapeExpression((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "elementId",
          "hash": {},
          "data": data
        }) : helper)) + "-control\"\n  class=\"visual-diff-support\"\n  style=\"width: 100%; ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.designer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "overflow: hidden;\"\n  ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.required : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n  ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readOnly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "</textarea>\n  <div class=\"clearfix\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.pdf.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"form-wrapper\">\n  <div class=\"form-section-container\">\n  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["comment.count"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "  <div tabindex=\"0\" class=\"content-padding-top\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.showCommentCount : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.showCommentAdd : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.open : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.program(12, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.unreadCount : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <span class=\"fa-icon-stack fa-icon-comment-stack\">\n          <span class=\"fa-icon fa-icon-comment fa-icon-stack-2x\"></span>\n            <span class=\"fa-icon fa-icon-inverse fa-icon-stack-1x comment-count\">" + escapeExpression((helper = (helper = helpers.unreadCount || (depth0 != null ? depth0.unreadCount : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "unreadCount",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n        </span>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "        <span class=\"fa-icon fa-icon-comment\"></span>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.open : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.program(8, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "8": function _(depth0, helpers, partials, data) {
      return "        <span class=\"fa-icon fa-icon-plus\"></span>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      return "      Collapse Comments\n";
    },
    "12": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.showCommentCount : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.showCommentAdd : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "13": function _(depth0, helpers, partials, data) {
      return "        Expand Comments\n";
    },
    "15": function _(depth0, helpers, partials, data) {
      return "        Add Comment\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.comments : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "useData": true
  });
  this["RSTemplates"]["comment.replyitem"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "last";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<span class=\"comment-author\">" + escapeExpression((helper = (helper = helpers.displayCreatePerson || (depth0 != null ? depth0.displayCreatePerson : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayCreatePerson",
        "hash": {},
        "data": data
      }) : helper)) + "</span> ";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "      <small><input type=\"hidden\" data-action=\"hide\"></small>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-simple btn-sm\" data-action=\"deleteReply\">Delete</div>\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-simple btn-sm\" data-action=\"edit\">Edit</div>\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canEdit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "12": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-simple btn-sm\" data-action=\"reply\">Reply</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda,
        buffer = "<div class=\"comment-reply-item ";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">\n  <div class=\"contents-toolbar\">\n    ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.displayCreatePerson : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " <small><span class=\"comment-date\">" + escapeExpression((helper = (helper = helpers.date || (depth0 != null ? depth0.date : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "date",
        "hash": {},
        "data": data
      }) : helper)) + "</span></small>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canHide : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  </div>\n  <div class=\"comment-body-title\" title=\"" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n  <div class=\"toolbar-actions\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canDelete : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canEdit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["comments.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <div class=\"comment-add content-margin\">\n    <textarea id=\"\" cols=\"30\" rows=\"5\"></textarea>\n  </div>\n  <div class=\"clearfix content-margin command-add-action-container\">\n    <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-xs comment-add-btn\"><i class=\"fa-icon fa-icon-pencil-square-o pull-right\"></i>Save Comment</div>\n  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"comment-list\"></div>\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canAdd : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["RSTemplates"]["comments.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        lambda = this.lambda,
        buffer = "<div class=\"comment-item ";
      stack1 = helpers['if'].call(depth0, data && data.odd, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.needsAddress : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.needsResolve : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hidden : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.complete : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canEdit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.needsFeedback : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">\n  <div class=\"comment-header\">\n\n    <div class=\"contents-toolbar\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.displayCreatePerson : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(19, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "      <small><span class=\"comment-date\">" + escapeExpression((helper = (helper = helpers.date || (depth0 != null ? depth0.date : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "date",
        "hash": {},
        "data": data
      }) : helper)) + "</span></small>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canHide : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(21, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n    </div>\n\n    <div>\n      <div class='comment-body-title' title=\"" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "\">";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n    </div>\n\n\n    <div class=\"toolbar-actions\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canEdit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(23, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canDelete : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canReply : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(27, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n\n    <div class=\"comment-reply-list\"></div>\n    <div class=\"comment-reply-container\"></div>\n\n    <div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canAddress : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(29, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canResolve : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(33, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.needsFeedback : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(37, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  </div>\n\n</div>\n";
      stack1 = helpers.unless.call(depth0, data && data.last, {
        "name": "unless",
        "hash": {},
        "fn": this.program(39, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      return "odd";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "needs-address";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "needs-resolve";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "is-hidden";
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hidden : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "11": function _(depth0, helpers, partials, data) {
      return "complete";
    },
    "13": function _(depth0, helpers, partials, data) {
      return "current-user-comment";
    },
    "15": function _(depth0, helpers, partials, data) {
      return "needs-feedback";
    },
    "17": function _(depth0, helpers, partials, data) {
      return "last";
    },
    "19": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <span class=\"comment-author\">" + escapeExpression((helper = (helper = helpers.displayCreatePerson || (depth0 != null ? depth0.displayCreatePerson : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayCreatePerson",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "21": function _(depth0, helpers, partials, data) {
      return "        <small><input type=\"hidden\" data-action=\"hide\"></small>\n";
    },
    "23": function _(depth0, helpers, partials, data) {
      return "        <div role=\"button\" tabindex=\"0\" class=\"btn btn-simple btn-sm\" data-action=\"edit\">Edit</div>\n";
    },
    "25": function _(depth0, helpers, partials, data) {
      return "        <div role=\"button\" tabindex=\"0\" class=\"btn btn-simple btn-sm\" data-action=\"delete\">Delete</div>\n";
    },
    "27": function _(depth0, helpers, partials, data) {
      return "        <div role=\"button\" tabindex=\"0\" class=\"btn btn-simple btn-sm\" data-action=\"reply\">Reply</div>\n";
    },
    "29": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hidden : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(30, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "30": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "          <input type=\"hidden\" data-action=\"address\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.addressed : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(31, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "31": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "            <small>&nbsp; " + escapeExpression((helper = (helper = helpers.addressedDateDisplay || (depth0 != null ? depth0.addressedDateDisplay : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "addressedDateDisplay",
        "hash": {},
        "data": data
      }) : helper)) + " by " + escapeExpression((helper = (helper = helpers.addressedPersonDisplay || (depth0 != null ? depth0.addressedPersonDisplay : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "addressedPersonDisplay",
        "hash": {},
        "data": data
      }) : helper)) + "</small>\n";
    },
    "33": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hidden : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(34, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "34": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "          <input type=\"hidden\" data-action=\"resolve\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.resolved : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(35, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "35": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "             &nbsp; <small class=\"comment-complete-date\">" + escapeExpression((helper = (helper = helpers.resolvedDateDisplay || (depth0 != null ? depth0.resolvedDateDisplay : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "resolvedDateDisplay",
        "hash": {},
        "data": data
      }) : helper)) + " by " + escapeExpression((helper = (helper = helpers.resolvedPersonDisplay || (depth0 != null ? depth0.resolvedPersonDisplay : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "resolvedPersonDisplay",
        "hash": {},
        "data": data
      }) : helper)) + "</small>\n";
    },
    "37": function _(depth0, helpers, partials, data) {
      return "      <div style=\"padding-top: 10px;\">\n        <div class=\"comment-feedback\">Feedback Requested</div>\n      </div>\n";
    },
    "39": function _(depth0, helpers, partials, data) {
      return "  <div class=\"comment-divider\"></div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.dontShow : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["RSTemplates"]["comments.reply"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"content-margin\">\n  <textarea name=\"\" id=\"\" cols=\"30\" rows=\"10\"></textarea>\n</div>\n<div class=\"clearfix comment-reply-button-container content-margin\">\n  <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-xs comment-reply-btn\">\n    <i class=\"fa-icon fa-icon-pencil-square-o pull-right\"></i>Save\n  </div>\n  <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-xs comment-cancel-reply-btn\">\n    <i class=\"fa-icon fa-icon-times pull-right\"></i>Cancel\n  </div>\n</div>\n<div class=\"clearfix\"></div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["editelement"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"editable-input-textarea-container\"><textarea rows=\"1\" ></textarea></div>\n<div>\n	<div class=\"editable-input-controls pull-right\">\n		<div role=\"button\" tabindex=\"0\" class=\"editable-btn accept pull-right\" aria-label=\"save\">\n			<span class=\"glyphicon glyphicon-ok\"></span>\n		</div>\n		<div role=\"button\" tabindex=\"0\" class=\"editable-btn cancel pull-right\" aria-label=\"cancel\">\n			<span class=\"glyphicon glyphicon-ban-circle\"></span>\n		</div>\n	</div>\n</div><div class=\"clear\"></div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.action"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "no-hide";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "has-text";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "last";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "left";
    },
    "9": function _(depth0, helpers, partials, data) {
      return "right";
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "color-" + escapeExpression((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "color",
        "hash": {},
        "data": data
      }) : helper));
    },
    "13": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "15": function _(depth0, helpers, partials, data) {
      return "large";
    },
    "17": function _(depth0, helpers, partials, data) {
      return "collapsed";
    },
    "19": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "aria-label=\"" + escapeExpression((helper = (helper = helpers.ariaLabel || (depth0 != null ? depth0.ariaLabel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "ariaLabel",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "21": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "aria-labelledby=\"" + escapeExpression((helper = (helper = helpers.ariaLabelledby || (depth0 != null ? depth0.ariaLabelledby : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "ariaLabelledby",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "23": function _(depth0, helpers, partials, data) {
      return "aria-disabled=\"true\"";
    },
    "25": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "	  <span class=\"form-action-icon font-awesome-icon fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + "\"></span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div role=\"button\"\n			tabindex=\"0\"\n			class=\"form-action ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.noHide : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, data && data.first, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.left : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.program(9, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.color : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.disabled : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.large : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.collapsed : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " " + escapeExpression((helper = (helper = helpers['class'] || (depth0 != null ? depth0['class'] : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "class",
        "hash": {},
        "data": data
      }) : helper)) + "\"\n			";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.ariaLabel : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(19, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n			";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.ariaLabelledby : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(21, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n			";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.disabled : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(23, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n			data-action=\"" + escapeExpression((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "action",
        "hash": {},
        "data": data
      }) : helper)) + "\"\n			data-value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(25, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  <span>" + escapeExpression((helpers.UpperCase || depth0 && depth0.UpperCase || helperMissing).call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "UpperCase",
        "hash": {},
        "data": data
      })) + "</span>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.attachment.row"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "    <span class=\"check-icon\"></span>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "    <span role=\"button\" tabindex=\"0\" class=\"attachment-delete-btn\"></span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"form-sidebar-attachment\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.viewer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  <div class=\"attachment-text\"><span>" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span></div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.dropcontrols"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "	  <div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "	  </div>\n	  <div><span class=\"arrow glyphicon glyphicon-arrow-down\"></span></div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "	      " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      return "	      Drag your answer | subquestion | group | element\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      return "	  <div class=\"form-object-spacer\"></div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"form-object-spacer last\"></div>\n<div class=\"form-object-drop-area\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.large : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(6, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        helperMissing = helpers.helperMissing,
        functionType = "function",
        escapeExpression = this.escapeExpression,
        buffer = "      <div class=\"form-actions\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.actions : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "      </div>\n      <div class=\"rs-navigation-previous\" role=\"button\" tabindex=\"0\" aria-label=\"return to templates\">\n        <span class=\"glyphicon glyphicon-chevron-left\"></span>\n        TEMPLATES\n      </div>\n      <div class=\"rs-navigation-divider\"></div>\n      <div class=\"rs-navigation-title\">\n        <div class=\"form-title bold\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n      </div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = this.invokePartial(partials['form.action'], '          ', 'form.action', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.preview : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.program(7, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <div class=\"col-xs-3\">\n          <div class=\"template-title bold\">" + escapeExpression((helper = (helper = helpers.templateTitle || (depth0 != null ? depth0.templateTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "templateTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n        </div>\n        <div class=\"template-preview-banner col-xs-9\">Preview Only</div>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        helperMissing = helpers.helperMissing,
        functionType = "function",
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"form-actions\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.actions : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        </div>\n        <div class=\"rs-navigation-previous\" role=\"button\" tabindex=\"0\" aria-label=\"return to submission details\">\n          <span class=\"glyphicon glyphicon-chevron-left\"></span>\n          SUBMISSION DETAILS\n        </div>\n        <div class=\"rs-navigation-divider\"></div>\n        <hgroup class=\"rs-navigation-title\">\n          <div role=\"heading\" aria-level=\"2\" class=\"form-label-title\"><span class=\"muted-dark\">IRB NUMBER:</span> <b>" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</b></div>\n          <div role=\"heading\" aria-level=\"3\" class=\"form-title bold\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n        </hgroup>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = this.invokePartial(partials['form.action'], '            ', 'form.action', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<header class=\"form-header\">\n  <div class=\"form-header-bottom\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n</header>\n<div class=\"form-wrapper\">\n  <div class=\"form-messages\"></div>\n  <nav id=\"sectionNav\" class=\"form-sidebar\" aria-labelledby=\"sectionsHeader\">\n    <div\n      id=\"sectionNavToggleBtn\"\n      role=\"button\"\n      tabindex=\"0\"\n      aria-expanded=\"true\"\n      aria-haspopup=\"menu\"\n      aria-controls=\"sectionItems\"\n      aria-label=\"close sections menu\"\n      class=\"form-sidebar-closer\">\n      <span class=\"fa-icon fa-icon-chevron-left\"></span>\n    </div>\n    <div id=\"sectionItems\" class=\"form-sidebar-scroller\">\n      <div id=\"sectionsHeader\" role=\"heading\" level=\"4\" class=\"form-sidebar-header\">" + escapeExpression((helper = (helper = helpers.headerTitle || (depth0 != null ? depth0.headerTitle : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "headerTitle",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n    </div>\n  </nav>\n  <section id=\"formContainer\" class=\"form-section-container\">\n  </section>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["form.notification.message"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"form-message " + escapeExpression((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "type",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n  " + escapeExpression((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "message",
        "hash": {},
        "data": data
      }) : helper)) + "\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.section.container"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"form-section-header\">\n  <strong class=\"section-label\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</strong> <span>" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.section.edit.container"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"form-section-header\"><strong class=\"editable-input section-label section-header-content form-section-label\" data-property=\"label\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</strong> <span class=\"editable-input section-header-content form-section-text\" data-property=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span></div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.section.lock"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "clear-bg";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"section-lock ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.clear : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.section.row"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "edit";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "go to";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "editable-section";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "    <span role=\"button\" tabindex=\"0\" aria-label=\"remove this section\" class=\"section-delete-btn\"></span>\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "    <div class=\"fa-icon-stack comment-icon pull-right\">\n      <i class=\"fa-icon fa-icon-comment fa-icon-stack-2x\"></i>\n      <div class=\"comment-counter fa-icon-stack-1x\" aria-label=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.comments : depth0) != null ? stack1.length : stack1, depth0)) + " comments\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.comments : depth0) != null ? stack1.length : stack1, depth0)) + "</div>\n    </div>\n    <i class=\"icon check pull-right teal large\"></i>\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      return "    <div class=\"dragger glyphicon glyphicon-align-justify\"></div>\n";
    },
    "13": function _(depth0, helpers, partials, data) {
      return "    <div class=\"percentage\"></div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div\n  role=\"menuitem\"\n  tabindex=\"0\"\n  aria-label=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\"\n  class=\"form-sidebar-section ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.program(9, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  <div class=\"section-text\"><span class=\"section-label\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span></div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.edit : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.program(13, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.sidebar.action"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div role=\"button\" tabindex=\"0\" class=\"form-sidebar-action-btn\">\n  <span class=\"glyphicon glyphicon-chevron-right pull-right\"></span>\n  " + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.toolbar.controls"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <div data-type=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"control-type\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"padding\">Drag an item from this pane onto the canvas to start building your form.</div>\n<div class=\"toolbar-controls-container\">\n  <div>\n    <h2>Layout</h2>\n  </div>\n";
      stack1 = helpers.each.call(depth0, (stack1 = depth0 != null ? depth0.controlTypes : depth0) != null ? stack1.groups : stack1, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  <div>\n    <h2>Questions</h2>\n  </div>\n";
      stack1 = helpers.each.call(depth0, (stack1 = depth0 != null ? depth0.controlTypes : depth0) != null ? stack1.others : stack1, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.toolbar"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"form-toolbar-container\">\n  <div class=\"form-toolbar-tab-container\">\n    <div class=\"form-toolbar-tab controls\">Items</div>\n    <div class=\"form-toolbar-tab properties\">Properties</div>\n  </div>\n  <div class=\"form-toolbar\"></div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["form.toolbar.properties"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        buffer = "    <div class=\"property-container ";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " clearfix\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.bool : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dropdown : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(16, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.label : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(20, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.button : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(22, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.list : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(24, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "last";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <div data-property=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "name",
          "hash": {},
          "data": data
        }) : helper)) + "\" data-class-bool=\"checked\" class=\"checkbox-custom pull-right ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.value : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.disabled : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " property-value\"></div>\n        <div class=\"property-name pull-left\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "checked";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "disabled";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"property-name\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "displayName",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.richtext : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.program(13, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "          <div class=\"property-richtext-container\">\n            <textarea ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.noLiveUpdate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " data-property=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"property-value richtext\">";
      stack1 = (helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</textarea>\n          </div>\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      return "data-no-live-update=\"true\"";
    },
    "13": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "          <input ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.maxLength : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " data-property=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.noLiveUpdate : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " class=\"form-control property-value text\" type=\"text\" value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "\" />\n";
    },
    "14": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return " maxLength=\"" + escapeExpression((helper = (helper = helpers.maxLength || (depth0 != null ? depth0.maxLength : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "maxLength",
        "hash": {},
        "data": data
      }) : helper)) + "\" ";
    },
    "16": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"property-name\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "displayName",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n        <select class=\"property-value property-tab-select\" data-property=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "name",
          "hash": {},
          "data": data
        }) : helper)) + "\" data-dropdown=\"" + escapeExpression((helper = (helper = helpers.valuesGetter || (depth0 != null ? depth0.valuesGetter : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "valuesGetter",
          "hash": {},
          "data": data
        }) : helper)) + "\">\n          <option value=\"\">None</option>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.values : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        </select>\n";
    },
    "17": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "            <option value=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selected : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(18, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "18": function _(depth0, helpers, partials, data) {
      return "selected=\"selected\"";
    },
    "20": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <div class=\"pull-right property-value\">" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n        <div class=\"property-name pull-left\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "22": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs property-button\" data-handler=\"" + escapeExpression((helper = (helper = helpers.handler || (depth0 != null ? depth0.handler : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "handler",
        "hash": {},
        "data": data
      }) : helper)) + "\" style=\"width: 100%;\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "24": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"property-name title pull-left\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "displayName",
          "hash": {},
          "data": data
        }) : helper)) + "</div><div class=\"clearfix\"></div>\n        <div data-property=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "name",
          "hash": {},
          "data": data
        }) : helper)) + "\" class=\"property-list\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.value : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(25, data, depths),
        "inverse": this.program(32, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        </div>\n";
    },
    "25": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "            <div data-list-item-id=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\" class=\"property-item\">\n              <div class=\"text\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.displayName : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(26, data, depths),
        "inverse": this.program(28, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "              </div>\n";
      stack1 = helpers['if'].call(depth0, depths[1] != null ? depths[1].deletable : depths[1], {
        "name": "if",
        "hash": {},
        "fn": this.program(30, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "              <div class=\"clearfix\"></div>\n            </div>\n";
    },
    "26": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                  " + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "28": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "                  " + escapeExpression((helper = (helper = helpers.fileName || (depth0 != null ? depth0.fileName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "fileName",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "30": function _(depth0, helpers, partials, data) {
      return "                <div role=\"button\" tabindex=\"0\" class=\"remove-btn\"></div>\n";
    },
    "32": function _(depth0, helpers, partials, data) {
      return "            <div>\n              No samples uploaded.\n            </div>\n";
    },
    "34": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        buffer = "<div>\n  <div class=\"toolbar-linked\">\n    <div class=\"linked-header\">\n      <span class=\"title\">Links</span>\n    </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canHaveLinks : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(35, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dependencies : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(41, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "35": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "    <div class=\"linked-list\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.links : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(36, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n";
    },
    "36": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"linked-type\"><span>" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "displayName",
          "hash": {},
          "data": data
        }) : helper)) + " </span><div class=\"plus-sign-icon glyphicon glyphicon-plus-sign pull-right\" data-type=\"" + escapeExpression((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "type",
          "hash": {},
          "data": data
        }) : helper)) + "\"></div></div>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.targets : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(37, data, depths),
        "inverse": this.program(39, data, depths),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "37": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "          <div class=\"";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " linked-item\" data-type=\"" + escapeExpression(lambda(depths[1] != null ? depths[1].type : depths[1], depth0)) + "\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n            <span>" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n            <div class=\"linked-controls pull-right\">\n              <span role=\"button\" tabindex=\"0\" class=\"glyphicon glyphicon-share-alt reveal-link-btn\"></span>\n              <span role=\"button\" tabindex=\"0\" class=\"glyphicon glyphicon-minus-sign remove-link-btn\"></span>\n            </div>\n          </div>\n";
    },
    "39": function _(depth0, helpers, partials, data) {
      return "            <div class=\"empty-list\">None</div>\n";
    },
    "41": function _(depth0, helpers, partials, data) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "    <div class=\"linked-list\">\n      <div class=\"linked-type\"><span>Linked By </span></div>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.dependencies : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(42, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "      </div>\n    </div>\n";
    },
    "42": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "        <div class=\"";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " linked-item\" data-id=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.target : depth0) != null ? stack1.id : stack1, depth0)) + "\">\n          <span>" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.target : depth0) != null ? stack1.name : stack1, depth0)) + "</span>\n          <div class=\"linked-controls pull-right\">\n            <span role=\"button\" tabindex=\"0\" class=\"glyphicon glyphicon-share-alt reveal-link-btn\"></span>\n          </div>\n        </div>\n";
    },
    "44": function _(depth0, helpers, partials, data) {
      return "<div>\n  <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs go-to-control-btn\">Find This Control</div>\n</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data, depths) {
      var stack1,
        helperMissing = helpers.helperMissing,
        buffer = "<div>\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.properties : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.shouldHideLinks : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(34, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canGoToControl : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(44, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true,
    "useDepths": true
  });
  this["RSTemplates"]["header.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "    <div class=\"badge-container content-margin-left\" data-name=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "name",
          "hash": {},
          "data": data
        }) : helper)) + "\">\n      <div class=\"badge-count\"></div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <i class=\"fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " badge-icon\"></i>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "  <div data-menu-index=" + escapeExpression(lambda(data && data.index, depth0)) + " class=\"nav-link ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.children : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.className : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.route : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    " + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\n    <div class=\"highlight\"></div>\n  </div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "menu-children";
    },
    "7": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.className || (depth0 != null ? depth0.className : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "className",
        "hash": {},
        "data": data
      }) : helper));
    },
    "9": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "data-route=\"" + escapeExpression((helper = (helper = helpers.route || (depth0 != null ? depth0.route : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "route",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "data-link=\"" + escapeExpression((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "link",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "13": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <i class=\"fa-icon fa-icon-" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + "\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"persona persona-menu pull-right\">\n  <div class=\"persona-icon glyphicon glyphicon-user pull-left\"></div> " + escapeExpression((helper = (helper = helpers.user || (depth0 != null ? depth0.user : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "user",
          "hash": {},
          "data": data
        }) : helper)) + "\n</div>\n\n<div style=\"position: relative;top: 3px;\" class=\"pull-right clearfix\">\n";
      stack1 = (helpers.foreach || depth0 && depth0.foreach || helperMissing).call(depth0, depth0 != null ? depth0.badges : depth0, {
        "name": "foreach",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n\n\n<span class=\"header-logo\"></span>\n<div class=\"product-navigation pull-left\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.navigationLinks : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n<div class=\"product-navigation-mini pull-left\">\n  <div role=\"button\" tabindex=\"0\" class=\"sprite-menu navigation-popup-btn\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["header.navigation.popup"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "			<li class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.children : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-route=\"" + escapeExpression((helper = (helper = helpers.route || (depth0 != null ? depth0.route : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "route",
        "hash": {},
        "data": data
      }) : helper)) + "\" data-link=\"" + escapeExpression((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "link",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n				" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.children : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "			</li>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "has-submenu";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "					<ul>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.children : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "					</ul>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "							<a href=\"" + escapeExpression((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "link",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.target : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "><li>" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</li></a>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "target=\"" + escapeExpression((helper = (helper = helpers.target || (depth0 != null ? depth0.target : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "target",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div>\n	<ul class=\"root-menus\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.menus : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "	</ul>\n</div>\n\n";
    },
    "useData": true
  });
  this["RSTemplates"]["header.submenu.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "href=\"" + escapeExpression((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "link",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "target=\"" + escapeExpression((helper = (helper = helpers.target || (depth0 != null ? depth0.target : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "target",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<li data-index=\"" + escapeExpression((helper = (helper = helpers.i || (depth0 != null ? depth0.i : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "i",
          "hash": {},
          "data": data
        }) : helper)) + "\">\n  <a ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.target : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n</li>";
    },
    "useData": true
  });
  this["RSTemplates"]["finder.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<div class=\"finder-filter\">\n  <div class=\"dynamic-container\">\n    <div role=\"button\" tabindex=\"0\" aria-label=\"search\" class=\"btn btn-default pull-right finder-search-btn\" data-action=\"filterBtn\">\n      <span class=\"fa-icon fa-icon-search\"></span>\n    </div>\n    <div class=\"dynamic-form-control finder-sub-section\">\n      <input class=\"form-control finder-filter-input\" type=\"text\" placeholder=\"Search...\"/>\n      <span aria-label=\"clear search\" role=\"button\" tabindex=\"0\" class=\"glyphicon glyphicon-remove finder-filter-clear\" data-action=\"clearFilter\"></span>\n    </div>\n  </div>\n</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "            <i class=\"single-select-label required-text\">Select a single record.</i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.filter : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n<div class=\"finder-container modal-sub-section\">\n  <div class=\"finder-items-container use-side-highlight\"></div>\n  <div class=\"finder-msg\"><i class=\"finder-msg-txt\"></i></div>\n</div>\n\n<div class=\"selected-container modal-sub-section\">\n  <table class=\"selected-table e3-table rs-theme\">\n    <thead>\n      <tr class=\"e3-table-header selected-table-header\">\n        <th scope=\"col\" class=\"e3-table-header-cell label-cell\">\n          Selected Records\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.singleSelect : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "        </th>\n        <th scope=\"col\" class=\"e3-table-header-cell remove-button-header\">\n          <span class=\"accessibility-text\">Remove this item</span>\n        </th>\n      </tr>\n    </thead>\n    <tbody class=\"e3-table-row-container selected-table-body\">\n      <tr class=\"e3-table-row e3-table-row-content selected-none-msg\">\n        <td class=\"e3-table-row-cell\" colspan=\"2\"><i>No records selected. Select a record and click <strong>Save</strong> to apply.</i></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["finder.search"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"input-container finder-filter\">\n  <input class=\"form-control finder-filter-input\" type=\"text\" placeholder=\"Search...\"/>\n  <i role=\"button\" tabindex=\"0\" class=\"fa-icon fa-icon-chevron-right finder-filter-btn\" data-action=\"FinderFilter\"></i>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["finder.selected"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "last";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<tr class=\"e3-table-row e3-table-row-content ";
      stack1 = helpers['if'].call(depth0, data && data.last, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\" data-id=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n  <td class=\"e3-table-row-cell\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</td>\n  <td class=\"e3-table-row-cell remove-button-cell\">\n      <div role=\"button\" tabindex=\"0\" class=\"btn-remove-item\" aria-label=\"unselect " + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "\"><i class=\"fa-icon fa-icon-times\"></i></div>\n  </td>\n</tr>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["legacy.upload.item.body"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"panel expanded\">\n  <div class=\"panel-heading\">Studies Failed to be Created<i class=\"fa-icon fa-icon-chevron-down\"></i><i class=\"fa-icon fa-icon-chevron-right\"></i></div>\n  <ul class=\"list-group danger\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.failure : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </ul>\n</div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "      <li class=\"list-group-item\" title=\"" + escapeExpression(lambda(depth0, depth0)) + "\">" + escapeExpression(lambda(depth0, depth0)) + "</li>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"panel expanded\">\n  <div class=\"panel-heading\">Studies Successfully Created<i class=\"fa-icon fa-icon-chevron-down\"></i><i class=\"fa-icon fa-icon-chevron-right\"></i></div>\n  <ul class=\"list-group success\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.success : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </ul>\n</div>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"panel expanded\">\n  <div class=\"panel-heading\">Studies Successfully Updated<i class=\"fa-icon fa-icon-chevron-down\"></i><i class=\"fa-icon fa-icon-chevron-right\"></i></div>\n  <ul class=\"list-group info\">\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.update : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </ul>\n</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.failure : depth0) != null ? stack1.length : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.success : depth0) != null ? stack1.length : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, (stack1 = depth0 != null ? depth0.update : depth0) != null ? stack1.length : stack1, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["RSTemplates"]["legacy.upload.modal"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"\">File Upload Status</div>\n\n<div class=\"modal-sub-section file-dropzone text-center content-margin\">\n DROP FILES TO ADD\n</div>\n\n<div class=\"clearfix\">\n  <div class=\"file-upload-group pull-left\">\n\n    <div class=\"upload-add-file-menu pull-right\">\n      <div role=\"button\" tabindex=\"0\" class=\"btn btn-default file-upload-btn\"><i class=\"fa-icon fa-icon-plus pull-right\"></i>Choose File</div>\n";
      stack1 = this.invokePartial(partials['hidden.fileinput'], '      ', 'hidden.fileinput', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n\n    <div class=\"modal-sub-section legacy-file-upload-container\">\n      <div class=\"queued-file-container\" style=\"display: none;\">\n      </div>\n\n      <div class=\"file-container\" style=\"display: none;\">\n      </div>\n\n      <div class=\"file-instructions text-center\">\n       <i>Click the plus button to upload files or add links.</i>\n      </div>\n    </div>\n\n  </div>\n</div>\n\n<div class=\"modal-sub-section file-failed-status\"></div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["system.report.modal"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"modal-input-container-wrapper\">\n        <div class=\"modal-input-wrapper-one\">\n            <label for=\"" + escapeExpression((helper = (helper = helpers.lookupLabelOne || (depth0 != null ? depth0.lookupLabelOne : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lookupLabelOne",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"control-label\">" + escapeExpression((helper = (helper = helpers.lookupLabelOne || (depth0 != null ? depth0.lookupLabelOne : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lookupLabelOne",
        "hash": {},
        "data": data
      }) : helper)) + "</label>\n            <select id=\"" + escapeExpression((helper = (helper = helpers.lookupLabelOne || (depth0 != null ? depth0.lookupLabelOne : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lookupLabelOne",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"js-example-basic-multiple\"></select>\n        </div>\n\n        <div class=\"modal-input-wrapper-two\">\n            <label for=\"" + escapeExpression((helper = (helper = helpers.lookupLabelTwo || (depth0 != null ? depth0.lookupLabelTwo : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lookupLabelTwo",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"control-label\">" + escapeExpression((helper = (helper = helpers.lookupLabelTwo || (depth0 != null ? depth0.lookupLabelTwo : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lookupLabelTwo",
        "hash": {},
        "data": data
      }) : helper)) + "</label>\n            <select id=\"" + escapeExpression((helper = (helper = helpers.lookupLabelTwo || (depth0 != null ? depth0.lookupLabelTwo : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "lookupLabelTwo",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"js-example-basic-multiple\"></select>                       \n        </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["tree.finder.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<div class=\"finder-filter modal-sub-section\">\n  <input class=\"form-control finder-filter-input\" type=\"text\" placeholder=\"Search...\"/>\n  <span class=\"glyphicon glyphicon-remove finder-filter-clear\" data-action=\"clearFilter\"></span>\n</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "        <i class=\"single-select-label required-text\">Select a single record.</i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.filter : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n<div class=\"finder-container modal-sub-section\">\n  <div class=\"finder-items-container\"></div>\n  <div class=\"finder-msg\"><i class=\"finder-msg-txt\"></i></div>\n</div>\n\n<div class=\"finder-item-btn clearfix\">\n  <div role=\"button\" tabindex=\"0\" class=\"btn btn-default pull-right\" data-action=\"selectTreeItem\">" + escapeExpression((helper = (helper = helpers.selectedText || (depth0 != null ? depth0.selectedText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "selectedText",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n</div>\n\n<div class=\"selected-container modal-sub-section\">\n  <div class=\"selected-table\">\n    <div class=\"selected-table-header\">\n      Selected Records\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.singleSelect : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n    <div class=\"selected-table-body\"></div>\n    <div class=\"selected-none-msg\"><i>No records selected. Select a record and click <strong>Save</strong> to apply.</i></div>\n  </div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["upload.error"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"upload-error-message red-font-color\">Error: " + escapeExpression((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "message",
        "hash": {},
        "data": data
      }) : helper)) + "</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["upload.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "queued";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <i class=\"fa-icon fa-icon-cloud-upload pull-left\"></i>\n        <i class=\"fa-icon fa-icon-times remove-queued-file\"></i> " + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\n        <div class=\"file-progress\">\n          <div class=\"file-name-clone e3-table-row-cell last\">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n        </div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "        <i class=\"fa-icon fa-icon-times remove-file\"></i>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.program(8, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "          <i class=\"fa-icon fa-icon-link pull-left\"></i>\n          <a href=\"" + escapeExpression((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "url",
        "hash": {},
        "data": data
      }) : helper)) + "\" target=\"_blank\">" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "          <i class=\"fa-icon fa-icon-file pull-left\"></i>\n          " + escapeExpression((helper = (helper = helpers.fileName || (depth0 != null ? depth0.fileName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "fileName",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"file-item ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.queued : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " e3-table-row\" data-uuid=\"" + escapeExpression((helper = (helper = helpers.uuid || (depth0 != null ? depth0.uuid : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "uuid",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n  <div class=\"e3-table-row-content\">\n    <div class=\"e3-table-row-cell last\" style=\"width: 100%;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.queued : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </div>\n  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["upload.modal"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<div class=\"single-attachment-warning required-text\">Single Attachment Only: Delete previous attachment to add another</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "\n<div class=\"modal-sub-section file-dropzone text-center content-margin\">\n DROP FILES TO ADD\n</div>\n\n<div class=\"add-link-form modal-sub-section content-margin e3-table rs-theme content-padding-bottom\" style=\"display: none;\">\n\n  <div class=\"e3-table-row-group content-margin\">Add Link</div>\n\n  <div class=\"container-fluid content-margin\">\n    <div class=\"row\">\n      <div class=\"col-md-3\">\n        <div class=\"form-group\">\n          <label for=\"link-title-text\">Title</label>\n          <input id=\"link-title-text\" type=\"text\" class=\"form-control link-title\" data-property=\"displayName\" >\n        </div>\n      </div>\n      <div class=\"col-md-9\">\n        <div class=\"form-group\">\n          <label for=\"link-url-text\">URL</label>\n          <input id = \"link-url-text\" type=\"text\" class=\"form-control link-url\" data-property=\"url\" >\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"clearfix content-padding\">\n    <div class=\"btn-rs-group pull-right\">\n      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view cancel-link-btn\"><i class=\"fa-icon fa-icon-ban pull-right\"></i>Cancel</div>\n      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs wide-view add-link-btn\"><i class=\"fa-icon fa-icon-plus pull-right\"></i>Add</div>\n    </div>\n  </div>\n\n</div>\n\n<div class=\"file-table e3-table modal-sub-section rs-theme\">\n  <div class=\"e3-table-row-container\">\n\n    <div class=\"queued-file-container\" style=\"display: none;\">\n      <div class=\"e3-table-row-group\">Files to Upload</div>\n    </div>\n\n    <div class=\"file-container\" style=\"display: none;\">\n      <div class=\"e3-table-row-group\">Files</div>\n    </div>\n\n    <div class=\"link-container\" style=\"display: none;\">\n      <div class=\"e3-table-row-group\">Links</div>\n    </div>\n\n    <div class=\"file-instructions text-center\">\n     <i>Click the plus button to upload files or add links.</i>\n    </div>\n\n  </div>\n</div>\n";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.multiple : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["RSTemplates"]["upload.submenu.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = this.invokePartial(partials['hidden.fileinput'], '    ', 'hidden.fileinput', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<li data-index=\"" + escapeExpression((helper = (helper = helpers.i || (depth0 != null ? depth0.i : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "i",
          "hash": {},
          "data": data
        }) : helper)) + "\" tabindex=\"-1\" aria-label=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "name",
          "hash": {},
          "data": data
        }) : helper)) + "\" style=\"position: relative; overflow: hidden;\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hiddenInput : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  <a tabindex=\"-1\">" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n</li>";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["notifications.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "      <div role=\"button\" tabindex=\"0\" class=\"btn btn-rs btn-xs notification-remove-all\">Clear All</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"notification-header\">\n  <div class=\"pull-right\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.removeAll : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "  </div>\n  <span>" + escapeExpression((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "displayName",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
      stack1 = this.invokePartial(partials['help.anchor'], '  ', 'help.anchor', depth0, undefined, helpers, partials, data);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n<div class=\"notification-container\">\n  <div class=\"notification-items\"></div>\n</div>\n";
    },
    "usePartial": true,
    "useData": true
  });
  this["RSTemplates"]["notifications.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "unread";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "urgent";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "selectable";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "      <i class=\"fa-icon fa-icon-times notification-remove\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"notification-item ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.unread : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.urgent : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selectable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\">\n  <div class=\"pull-right\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.canDelete : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n  <div class=\"notification-title\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n  <div class=\"notification-date\">" + escapeExpression((helper = (helper = helpers.date || (depth0 != null ? depth0.date : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "date",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n  <div class=\"notification-body\">" + escapeExpression((helper = (helper = helpers.body || (depth0 != null ? depth0.body : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "body",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["app"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<header class=\"content-padding\" role=\"banner\" aria-label=\"Site Header\" id=\"header\"></header>\n<main id=\"content\" aria-label=\"content\" tabindex=\"-1\"></main>\n<div id=\"modal-global\" class=\"modal fade\" tabindex=\"-1\"></div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["content.footer"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"content-footer\"></div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["form.control.validation"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"" + escapeExpression((helper = (helper = helpers.validationName || (depth0 != null ? depth0.validationName : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "validationName",
        "hash": {},
        "data": data
      }) : helper)) + "-error input-error\">\n  <div class=\"error-close right\"><i class=\"fa-icon fa-icon-times\"></i></div>\n  <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i> </div>\n  <span class=\"error-message\"></span>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["hidden.fileinput"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "multiple=\"multiple\" name=\"files[]\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "name=\"file\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<input type=\"file\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.multiple : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " class=\"hidden-file-upload\" />";
    },
    "useData": true
  });
  this["RSTemplates"]["init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div id=\"app\">\n  <div id=\"login\"></div>\n  <div id=\"modal-global\" class=\"modal fade\" tabindex=\"-1\"></div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["sidebar.content.init"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"content-page-width full-height\">\n  <div class=\"content-header content-underline\">\n    <div class=\"clearfix navigation-header content-padding\">\n      <div class=\"rs-navigation-title\">\n        <div class=\"large-title-text\">\n          Departments <span class=\"node-title\"></span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"clearfix\"></div>\n  <div class=\"main-wrapper\">\n    <div class=\"left-wrapper\">\n      <div class=\"main-sidebar\">\n        <div class=\"sidebar-closer\"><span class=\"sprite-menu\"></span></div>\n        <div class=\"sidebar-header border-shadow\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n        <div class=\"sidebar-content-container\"></div>\n      </div>\n    </div>\n    <div class=\"right-wrapper\">\n      <div class=\"inner-padding\">\n        <div class=\"main-content\"></div>\n      </div>\n    </div>\n  </div>\n</div>";
    },
    "useData": true
  });
  this["RSTemplates"]["sidebar"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"hierarchy-controls\">\n  <div class=\"hierarchy-filter\">\n    <div class=\"form-control\">\n      <input class=\"hierarchy-filterTxt filter-option\" type=\"text\" placeholder=\"" + escapeExpression((helper = (helper = helpers.filterDesc || (depth0 != null ? depth0.filterDesc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "filterDesc",
          "hash": {},
          "data": data
        }) : helper)) + "\"/>\n      <span class=\"glyphicon glyphicon-remove clear-hierarchy-filter\"></span>\n    </div>\n  </div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.selectFilter : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.hideAddBtn : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <div class=\"hierarchy-filter\">\n    <select class=\"hierarchy-filterSelect form-control\">\n      <option value=\"\">" + escapeExpression((helper = (helper = helpers.emptyDefault || (depth0 != null ? depth0.emptyDefault : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "emptyDefault",
          "hash": {},
          "data": data
        }) : helper)) + "</option>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.options : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "    </select>\n  </div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <option value=\"" + escapeExpression((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "id",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</option>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div role=\"button\" tabindex=\"0\" class=\"hierarchy-control border-shadow addChildBtn\"><span class=\"btn-sprite sprite-circled-plus-white-small\"></span>" + escapeExpression((helper = (helper = helpers.addDesc || (depth0 != null ? depth0.addDesc : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "addDesc",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.filterDesc : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<div class=\"hierarchy-scroller unselectable\">\n  <div class=\"hierarchy-container\"></div>\n</div>\n";
    },
    "useData": true
  });
  this["RSTemplates"]["sidebar.init"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <div class=\"main-content-header\">\n        <span class=\"content-title\">" + escapeExpression((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "header",
        "hash": {},
        "data": data
      }) : helper)) + "</span> <span class=\"node-title\"></span>\n      </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"main-wrapper\">\n  <div class=\"left-wrapper\">\n    <div class=\"main-sidebar\">\n      <div class=\"sidebar-closer\"><span class=\"sprite-menu\"></span></div>\n      <div class=\"sidebar-header\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "title",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n      <div class=\"sidebar-content\"></div>\n    </div>\n  </div>\n  <div class=\"right-wrapper\">\n    <div class=\"inner-padding\">\n";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.noheader : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "      <div class=\"main-content\"></div>\n    </div>\n  </div>\n</div>";
    },
    "useData": true
  });
  return this["RSTemplates"];
});

